import { injectPersonalData } from '../pages/impressum/impressumUtils.js';

const baseTranslationFR = {
  title: 'Mentions légales',
  subtitle: 'Informations conformément au § 5 DDG (loi allemande sur les services numériques)',
  serviceProvider: 'Prestataire de services',
  contactTitle: 'Contact',
  addressLabel: 'Adresse',
  contactLabel: 'Adresse e-mail',
  professionalTitle: 'Informations sur l’entreprise',
  professionLabel: 'Forme juridique',
  businessTypeLabel: 'Nature de l’activité',
  taxTitle: 'Informations fiscales',
  liabilityTitle: 'Limitation de responsabilité',
  contentLiabilityTitle: 'Responsabilité relative aux contenus',
  contentLiability: 'En tant que prestataire de services, nous sommes responsables de nos propres contenus sur ces pages conformément au § 7, al. 1 DDG et aux lois générales. En vertu des §§ 8 à 10 DDG, nous ne sommes toutefois pas tenus, en tant que prestataire de services, de surveiller les informations de tiers transmises ou stockées, ni de rechercher des circonstances révélant une activité illicite.',
  linkLiabilityTitle: 'Responsabilité relative aux liens',
  linkLiability: 'Notre offre contient des liens vers des sites web externes de tiers, sur les contenus desquels nous n’avons aucune influence. Nous ne pouvons donc assumer aucune garantie quant à ces contenus externes. Le fournisseur ou l’exploitant des pages liées est toujours responsable de leurs contenus. Les pages liées ont été vérifiées au moment de la création du lien afin de détecter d’éventuelles infractions à la loi. Aucun contenu illicite n’était identifiable à ce moment-là.',
  copyrightTitle: 'Droit d’auteur',
  copyright: 'Les contenus et les œuvres créés par l’exploitant du site sur ces pages sont soumis au droit d’auteur allemand. La reproduction, l’adaptation, la diffusion et toute forme d’exploitation en dehors des limites du droit d’auteur nécessitent l’autorisation écrite de l’auteur ou du créateur concerné. Les téléchargements et les copies de ce site ne sont autorisés que pour un usage privé et non commercial.'
};

export const localeFR = {
  nav: {
    title: 'pAIoneer Labs GmbH',
    home: 'Accueil',
    team: 'Équipe',
    events: 'Événements',
    finance: 'IA financière',
    teaching: 'Formation',
    agenticdev: 'IDD / Codage agentique',
    iddLegacy: 'Moderniser les logiciels hérités',
    iddMethod: 'Intent-Driven Development',
    veridion: 'Veridion',
    kyveil: 'Anonymisation',
    quantum: 'IA quantique',
    login: 'Connexion',
    openApp: 'Ouvrir l’application',
    account: 'Compte',
    admin: 'Admin',
    logout: 'Déconnexion',
    languageNames: {
      en: 'Anglais',
      de: 'Allemand',
      nl: 'Néerlandais',
      uk: 'Ukrainien',
      fr: 'Français',
      it: 'Italien',
      es: 'Espagnol',
      sv: 'Suédois',
      fi: 'Finnois',
      ja: 'Japonais',
      pl: 'Polonais',
      bg: 'Bulgare'
    }
  },
  admin: {
    datalake: {
      loading: "Chargement …",
      loadFailed: "Le data lake est injoignable",
      refresh: "Actualiser",
      generatedAt: "État au",
      notRolled: "Cette zone n'est pas encore déployée côté backend. Dès que les nouveaux points de terminaison seront en ligne, l'état mesuré apparaîtra ici.",
      loadMore: "Charger plus",
      yes: "oui",
      no: "non",
      none: "aucun",
      close: "Fermer",
      summaryTitle: "Deux hypothèses, un établi",
      summaryBody: "L'hypothèse d'architecture dit : le réceptacle mathématique décide de ce que le modèle peut devenir — elle vit sur la page du papier LLM. L'hypothèse des données dit : seules des données d'entraînement reliées et vérifiées remplissent ce réceptacle — cette page la sert. L'autopilote remplit le patrimoine de données en continu, lance l'entraînement dès que le plan de données du papier est atteint dans chaque domaine, en allemand et en anglais, mesure le résultat avec la suite de benchmarks et publie le modèle en privé sur HuggingFace. Chaque chiffre ici est mesuré ou signalé comme valeur configurée.",
      summaryArchButton: "Vers l'hypothèse d'architecture (papier LLM)",
      apTitle: "Autopilote",
      tpTitle: "Chemin vers le démarrage de l'entraînement",
      tpSubtitle: "Où en est le pilote automatique : chaque étape jusqu'à l'entraînement en cours, avec état, durée et progression.",
      tpNow: "Maintenant",
      tpStep: "Étape",
      tpOf: "sur",
      tpSince: "depuis",
      tpFor: "en cours depuis",
      tpHeartbeat: "dernier signe de vie",
      tpDone: "terminé",
      tpRunning: "en cours",
      tpWaiting: "en attente",
      tpFailed: "échoué",
      tpSkipped: "ignoré",
      tpProgress: "Progression",
      tpRows: "lignes",
      tpRate: "par seconde",
      tpRemaining: "temps restant estimé",
      tpEstimateNote: "estimation à partir des compteurs mesurés",
      tpPhaseReading: "lecture d'un paquet de données",
      tpPhaseAdmission: "admission (doublons, entropie)",
      tpPhaseEncoding: "tokenisation",
      tpNoTiming: "Cette version du moteur ne transmet pas encore les durées.",
      tpBlockers: "Blocages et erreurs",
      tpNone: "Aucun blocage.",
      trTitle: "Exécution d'entraînement (en direct)",
      trSubtitle: "Lu directement dans le répertoire d'exécution de l'entraîneur — fonctionne aussi pendant le redémarrage du worker.",
      trNoRun: "Aucune exécution d'entraînement avec des données de progression pour l'instant.",
      trStateTraining: "en entraînement",
      trStateStarting: "démarrage",
      trStateFinished: "terminé",
      trStateSilent: "silencieux depuis {age}",
      trStep: "Étape",
      trOf: "sur",
      trRemaining: "Temps restant (estimation d'après la vitesse mesurée)",
      trSecondsPerStep: "s par étape",
      trProgress: "Progression des étapes prévues",
      trRun: "Exécution",
      trResumed: "reprise à l'étape {step}",
      trVersion: "Version des données d'entraînement",
      trModel: "Modèle",
      trTokensPerSecond: "Tokens/s",
      trTokensSeen: "Tokens vus",
      trVram: "Mémoire GPU",
      trCap: "plafond",
      trLastHeartbeat: "Dernier heartbeat",
      trAgo: "il y a {age}",
      trShardReads: "Lectures de shards en local / via le worker",
      trLossTitle: "Évolution de la perte (loss)",
      trLossTotal: "Total",
      trLossNtp: "Token suivant",
      trLossMtp: "Multi-token",
      trChartEmpty: "Aucune étape signalée pour l'instant.",
      trAxisNote: "Horizontal : étape d'entraînement, vertical : perte (logarithme naturel). Survolez la courbe pour voir les valeurs d'une étape.",
      trValue: "Valeur",
      trCurrentValue: "actuel",
      trPoints: "{count} points de mesure au total",
      trStages: "Étapes du curriculum",
      trStageFoundation: "Fondation (texte brut)",
      trStageCapability: "Compétences",
      trStageAnneal: "Anneal",
      trStageCurrent: "en cours",
      trStageDone: "terminée",
      trStageAhead: "à venir",
      trShards: "shards",
      trRows: "lignes",
      trCheckpoint: "Checkpoint le plus récent",
      trCheckpointNone: "aucun pour l'instant",
      trCheckpoints: "Checkpoints complets sur le disque",
      trCheckpointEvery: "toutes les {minutes} min",
      trKernels: "Kernels actifs",
      trDeviations: "Écarts",
      trBlockStorage: "Copie dans le block storage",
      trBlockStorageNone: "aucune pour l'instant — la première suit le premier checkpoint",
      trUploading: "envoi en cours : étape {step}",
      treeCkRun: "Exécution d'entraînement",
      treeCkCopy: "Checkpoint dans le block storage, copié {time}",
      treeCkLocal: "Checkpoint sur le disque du serveur",
      treeCkUploading: "en cours de copie vers le block storage",
      trKpiProgress: "Progression",
      trKpiTokens: "Tokens",
      trKpiThroughput: "Débit",
      trKpiLoss: "Perte",
      trKpiLr: "Taux d'apprentissage",
      trKpiGpu: "Mémoire GPU",
      trEndAt: "fin vers {time}",
      trSeenPlanned: "vus / prévus",
      trBest: "meilleure {value}",
      trHourAgo: "{value} par rapport à il y a 1 h",
      trPerplexity: "perplexité {value}",
      trPhaseWarmup: "échauffement",
      trPhaseCosine: "décroissance cosinus",
      trPhaseStable: "phase stable",
      trPhaseDecay: "refroidissement",
      trKpiEpoch: "Époque",
      trEpochValue: "{epoch} sur {epochs}",
      trPlanTitle: "Plan d’entraînement",
      trPlanExplain: "Montée en température jusqu’au taux d’apprentissage maximal, puis constant sur quatre époques mélangées du corpus ; la phase de refroidissement entraîne sur le mélange de plus haute qualité (échantillons de compétences, textes de manuel, anneal) et ramène le taux d’apprentissage à zéro.",
      trPlanPhase: "Phase",
      trPlanStableSteps: "Pas prévus de la phase stable",
      trPlanDecay: "Refroidissement",
      trPlanDecayAhead: "à partir du pas {step} · dans environ {time}",
      trPlanDecayAheadNoTime: "à partir du pas {step}",
      trPlanDecayRunning: "depuis le pas {step} · {steps} pas jusqu’au taux d’apprentissage zéro",
      trPlanTokensPerStep: "Tokens par pas d’optimisation",
      trPlanTokensPerStepValue: "{tokens} ({accum} micro-lots)",
      trPlanRecompute: "Recalcul des activations",
      trPlanRecomputeOn: "activé – mesuré plus rapide avec un micro-lot plus grand",
      trPlanRecomputeOff: "désactivé – mesuré plus rapide sans",
      trPlanFim: "Documents au format fill-in-the-middle jusqu’ici",
      tbTitle: "Programme manuel",
      tbSubtitle: "Textes de fondation réécrits par des modèles enseignants en texte de manuel ; chaque nombre et chaque nom propre doit figurer dans la source.",
      tbTokens: "Tokens de manuel",
      tbTokensSub: "{pct} % de l’objectif de {target}",
      tbSamples: "Réécritures admises",
      tbJobs: "Tâches terminées",
      tbTeacher: "Tokens enseignant par token de manuel",
      tbCost: "Coût par million de tokens de manuel",
      tbCostNone: "la passerelle ne communique pas de coût ; les tokens enseignant sont comptés",
      tbExplain: "Tourne en parallèle de l’entraînement ; les époques suivantes et le refroidissement lisent ce qui est scellé d’ici là.",
      trThroughputTitle: "Débit (tokens/s)",
      trCurriculumTitle: "Curriculum",
      trStageTokens: "{tokens} tokens",
      trStageBegins: "commence à l'étape {step}",
      trPlanWarningLabel: "Attention",
      trPlanWarning: "L'exécution se termine après {max} étapes dans la phase « {stage} » — les données de compétences ne commencent qu'à l'étape {cap}. Un passage complet nécessiterait {steps} étapes (≈ {days} jours).",
      trPlanOk: "Les étapes prévues atteignent la phase « {stage} ».",
      trCheckpointsTitle: "Checkpoints",
      trNextCheckpoint: "Prochain checkpoint",
      trInSpan: "dans {span}",
      trResumes: "Reprise",
      trNoResume: "aucune",
      trConfig: "Configuration",
      trHealth: "État",
      trMicroBatch: "Micro-lot / tokens par étape",
      trSeqLen: "Longueur de séquence",
      trLrPlan: "Plan du taux d'apprentissage",
      trLrPlanValue: "pic {lr}, échauffement {warmup} étapes, cosinus jusqu'à l'étape {max}",
      trSpikes: "Pics de perte (dernière heure)",
      trProgressSub: "étape {step} sur {max} · entraîne depuis {elapsed}",
      trTokensSub: "sur {planned} prévus",
      trPathTrainingDetail: "{pct} % · étape {step} sur {max} · fin vers {end}",
      trReadinessRunning: "L'entraînement est en cours : {pct} % effectués (étape {step} sur {max}), perte {loss}, fin vers {end}.",
      tdvDraftsHistory: "Brouillons plus anciens, jamais scellés ({count})",
      runsHistory: "Exécutions interrompues et échouées ({count})",
      trAxisStep: "Étape d'entraînement",
      trAxisLoss: "Perte (logarithme naturel)",
      trCountdown: "{d} j {h} h {m} min {s} s",
      trTimerWaiting: "Le minuteur suit les premières mesures.",
      trTimerStageEnds: "La phase « {stage} » se termine dans",
      trTimerAt: "à {time}",
      trTimerNext: "Ensuite « {stage} » : {span}, à partir de {time}",
      trTimerRunEnds: "L'exécution se termine dans {span} (à {time})",
      trStepTimeSub: "{wall} s par étape mesurées · calcul {compute} s",
      trEtaTitle: "Temps restant d'après la durée d'étape mesurée",
      trEtaEpochEnds: "L'époque {epoch} sur {epochs} se termine dans",
      trEtaEpochAt: "à {time} (étape {step})",
      trEtaNextEpoch: "Époque {epoch} : à partir de {time} (étape {step})",
      trEtaDecay: "La phase de refroidissement commence dans {span} (à {time}, étape {step})",
      trEtaBasis: "Base : {wall} s par étape, moyenne des {n} dernières étapes sans {pauses} pauses (relance, arrêt) ; temps de calcul selon l'entraîneur {compute} s par étape.",
      devTitle: "Écarts par rapport au plan",
      devNone: "Aucun écart : l'exécution suit entièrement le plan.",
      devPlanned: "prévu",
      devLimit: "limitation",
      devSeqLen: "Longueur de contexte",
      devSeqLenText: "Entraîné avec {trained} tokens de contexte au lieu des {spec} prévus par le plan. Le contexte long arrive dans une phase ultérieure.",
      devFim: "Remplissage de trous (FIM)",
      devFimText: "L'objectif de remplissage de trous ({rate} % des blocs) est déclaré dans le plan mais pas encore actif dans cette exécution.",
      devTermination: "Sonde d'arrêt",
      devTerminationText: "La sonde d'arrêt n'est pas un objectif d'entraînement mais un mode à part après l'entraînement ; elle s'exécute plus tard sur un checkpoint terminé.",
      devDecision: "Objectif de décision",
      devDecisionText: "L'objectif de décision est actif, mais aucune marque de décision n'est arrivée dans les phases post-entraînement de cette exécution.",
      devKernelOff: "Accélération désactivée",
      devKernelUnverifiedText: "Le kernel « {kernel} » n'a pas été vérifié par la sonde et s'exécute en calcul standard.",
      devKernelUnavailableText: "Le kernel « {kernel} » n'est pas disponible sur cette carte et s'exécute en calcul standard.",
      devKernelFellBackText: "Le kernel « {kernel} » est retombé en calcul standard pendant l'exécution ({reason}).",
      devOptimizer: "Optimiseur",
      devOptimizerText: "Les états de l'optimiseur sont en bfloat16 au lieu de 8 bits (bitsandbytes indisponible) : plus de mémoire, mêmes mathématiques.",
      devScale: "Taille du modèle",
      devScaleText: "Le modèle est instancié à {scale} % de la taille du plan, car la taille complète ne tenait pas dans la mémoire mesurée.",
      devMediaHeads: "Têtes média",
      devMediaHeadsText: "Les têtes image/audio ne sont pas entraînées car les données ne contiennent aucun token média — prévu pour un brin texte.",
      devVision: "Voie vision",
      devVisionText: "La voie vision est construite mais a été entraînée sur zéro image, car les données n'en contiennent aucune.",
      devOther: "Autre",
      trStageShare: "{pct} % de cette phase effectués",
      cap_tool_calling: "Appels d'outils",
      cap_deep_reasoning: "Raisonnement approfondi",
      cap_software_engineering: "Développement logiciel",
      cap_office_finance: "Bureau & finance",
      cap_doc_understanding: "Compréhension de documents",
      tpExplainThresholds: "Pour chaque compétence du brin choisi, assez d'exemples vérifiés doivent se trouver dans le data lake. Objectif et mesure figurent ici par compétence.",
      tpThresholdsDetail: "{met} compétences sur {total} ont atteint leur objectif",
      tpThresholdRow: "{measured} exemples",
      tpForeignThresholds: "Pas pour ce brin : {list} — appartient à un autre brin et ne bloque rien.",
      tpStepTokenizerReleaseExplain: "Le tokenizer transforme le texte en nombres. Il est fixé une fois et déclaré à l'architecture, pour que données et modèle parlent la même langue.",
      tpStepTokenizeTdvExplain: "Tous les exemples vérifiés sont traduits en suites de nombres avec le tokenizer fixé.",
      tpStepTokenizeCorpusExplain: "Tout le texte brut du data lake est traduit en suites de nombres : la masse pour la fondation.",
      tpStepTdvCreateExplain: "Une version fixe des données d'entraînement (TDV) est assemblée à partir de toutes les données tokenisées, avec curriculum et masse de tokens mesurée.",
      tpStepTdvSealExplain: "La version est rendue immuable et copiée, avec sa description, dans le block storage.",
      tpStepCompatExplain: "Douze règles vérifient que version et architecture s'accordent (tokenizer, longueur de contexte, objectifs, mémoire). Toutes doivent être au vert.",
      tpStepVramExplain: "Mesure sur la carte si assez de mémoire GPU est libre pour le besoin déclaré.",
      tpVramDetail: "{free} Go libres, {need} Go nécessaires",
      tpStepTrainStartExplain: "Le pilote automatique lance l'exécution dès que toutes les conditions sont remplies.",
      tpStepTrainingExplain: "L'exécution s'entraîne seule avec des checkpoints toutes les 30 minutes et reprend d'elle-même après toute interruption. Détails sur la page « Entraînement & publication ».",
      tpVramRunning: "carte occupée par l'entraînement en cours ({need} Go nécessaires) ; rempli au démarrage",
      trPathTrainingDetailNoEnd: "{pct} % · étape {step} sur {max}",
      srTitle: "Préparation des données par brin de modèle",
      srSubtitle: "Pendant qu'un brin s'entraîne, le data lake continue de préparer les données des autres — jusqu'à leur propre version scellée, sans démarrage d'entraînement.",
      srTrainingNow: "en entraînement",
      srSelected: "sélectionné",
      srDataReady: "données prêtes",
      srPreparing: "en préparation",
      srModalities: "entrée : {in} · sortie : {out}",
      srThresholds: "objectifs : {met} sur {total} atteints",
      srCorpus: "Corpus tokenisé",
      srCorpusValue: "{tokens} tokens dans {shards} paquets de données",
      srVersion: "Version la plus récente",
      srNoVersion: "aucune pour l'instant",
      srLacking: "Manque encore",
      srLacksNothing: "rien : la version attend son brin",
      srLackThresholds: "objectifs non atteints",
      srLackCodec: "codec image/audio non publié",
      srLackTokenizer: "tokenizer non déclaré",
      srLackVersion: "aucune version scellée",
      srSelectedNote: "Ce brin s'entraîne en ce moment ; son chemin figure ci-dessus.",
      srSelectedIdleNote: "Ce brin est sélectionné pour le prochain entraînement ; son chemin figure ci-dessus.",
      srUnselectedNote: "Ce brin ne démarre aucun entraînement tant qu'un autre est sélectionné ; ses données sont néanmoins entièrement préparées.",
      modText: "texte",
      modImage: "image",
      modAudio: "audio",
      modVideo: "vidéo",
      tpStepThresholds: "Atteindre les objectifs",
      tpStepPlan: "Atteindre le plan de données du papier",
      tpExplainPlan: "Le papier fixe combien de tokens uniques et vérifiés chaque domaine exige. L'allemand et l'anglais en portent chacun au moins la moitié ; le code compte sans langue. On compte les tokens admis après suppression des doublons, pas l'estimation brute.",
      tpPlanDetail: "{met} domaines sur {total} atteints",
      tpPlanRowLang: "{have} / {target} · allemand {de} / {half} · anglais {en} / {half}",
      tpPlanRowFree: "{have} / {target}",
      tpPlanOpen: "ouvert : {langs}",
      tpLangDe: "allemand",
      tpLangEn: "anglais",
      tpPlanProvisional: "Compté provisoirement avec l'ancien tokenizer ; c'est le nouveau qui fait foi.",
      tpStepOwnTokenizer: "Tokenizer propre du brin",
      tpStepOwnTokenizerExplain: "Le brin s'entraîne avec son propre tokenizer, appris sur un corpus équilibré qui inclut du code. Ce n'est qu'en ses tokens que le plan de données compte définitivement.",
      tpPlanCat_knowledge: "Connaissances",
      tpPlanCat_code: "Code",
      tpPlanCat_mathematics: "Mathématiques",
      tpPlanCat_domain: "Textes spécialisés",
      tpPlanCat_textbook: "Manuel",
      tpPlanCat_agentic: "Exemples agentiques",
      tpPlanFlow: "flux entrant {rate} par heure",
      tpPlanEtaDays: "encore environ {n} jours",
      tpPlanEtaHours: "encore environ {n} heures",
      tpPlanNoFlow: "aucun flux entrant ces 24 dernières heures",
      tpPlanBinding: "goulot d'étranglement",
      tpBind_download: "téléchargement",
      tpBind_allowance: "le quota quotidien du block storage",
      tpBind_ingest: "ingestion",
      tpBind_teachers: "modèles enseignants",
      thrPlanTitle: "Exemples par compétence (mesurés)",
      thrPlanNote: "Les objectifs de ce brin sont fixés par son papier : le plan de données par domaine, en allemand et en anglais, sur le chemin vers le démarrage de l'entraînement. Les seuils par compétence ne valent que pour les brins sans plan de données ; on lit ici ce que chaque compétence contient, mesuré.",
      thrPlanRow: "{samples} exemples · {tokens} tokens",
      srDataPlan: "Plan de données du papier : {met} domaines sur {total} atteints",
      srLackDataPlan: "plan de données non atteint",
      srPlanOpen: "ouvert : {areas}",
      tpBind_source: "aucune source dans cette langue",
      tpBind_paused: "téléchargement en pause",
      tdvPlanEmpty: "Pas encore de version de données de la spécification active. L'autopilote la construit et la scelle dès que le plan de données du papier est atteint.",
      compatPlanNone: "Pas encore de vérification : la version de la spécification active est vérifiée lorsqu'elle est scellée.",
      mixPlanTitle: "Mélange selon le papier",
      mixPlanNote: "Chaque pas d'entraînement tire les domaines selon ces parts fixes ; la phase de décroissance porte la part de haute qualité jusqu'à la moitié. Les objectifs de mélange par compétence ne valent que pour les brins sans plan de données.",
      mixPlanShare: "{area} {pct} %",
      sitTitle: "Situation",
      sitSubtitle: "Où en est l'entraînement d'un coup d'œil : ce qui manque encore dans chaque domaine du papier, ce qui tourne maintenant et ce qui suit.",
      sitHeadlineDays: "L'entraînement peut démarrer au plus tôt dans environ {time} ; le plus long est {area} (goulot : {bottleneck}).",
      sitHeadlineBlocked: "Ainsi le plan de données n'est pas atteint : {items} n'a pas de source. On y travaille : rechercher des jeux de données ouverts ou traduire avec contrôle.",
      sitHeadlineReached: "Le plan de données est atteint ; suivent le tokenizer, la nouvelle tokenisation, le scellement et les contrôles.",
      sitHeadlineUnknown: "Le flux du reste n'est pas encore mesuré.",
      sitHold: "Le démarrage est en outre suspendu jusqu'à ce que chaque brique soit vérifiée.",
      sitArea: "Domaine",
      sitTotal: "Total",
      sitFlow: "Flux entrant",
      sitLeft: "Reste",
      sitBottleneck: "Goulot",
      sitNoLanguage: "sans langue",
      sitNoSource: "aucune source",
      sitReached: "atteint",
      sitDays: "{n} jours",
      sitHours: "{n} h",
      sitPerHour: "{value} par heure",
      sitPerHourTokens: "{value} tokens par heure",
      sitRunningTitle: "Ce qui tourne maintenant",
      sitDownloads: "Téléchargements",
      sitIngest: "Traitement en extraits de texte",
      sitTokenize: "Tokenisation",
      sitGenerate: "Génération par des modèles enseignants",
      sitIdle: "au repos",
      sitNextTitle: "Ce qui suit",
      sitNextSteps: "Entraîner le tokenizer avec du code → retokeniser tout le corpus → sceller la version → contrôles → démarrage de l'entraînement",
      sitProvisional: "Les quantités sont comptées provisoirement avec l'ancien tokenizer ; le nouveau compte définitivement.",
      tpPlanSeeSituation: "Domaines, langues et temps restants figurent dans la situation ci-dessus.",
      sitHeadlineBlocks: "L'entraînement ne peut pas encore démarrer : il manque des briques qui restent à construire ({items}). Les données croissent pendant ce temps.",
      sitDuration: "Durée de l'entraînement : environ {days} jours pour {budget} tokens aux {rate} tokens par seconde mesurés sur le même réseau.",
      sitBlocksTitle: "Briques de l'entraînement",
      sitStateNotBuilt: "pas encore construit",
      sitStateWaiting: "attend",
      sitStateReady: "prêt",
      sitBlockWaitsFor: "attend : {items}",
      sitBenchProgress: "{made} sur {total} tâches vérifiées",
      sitBlockParts: "construit : {built} · ouvert : {open}",
      part_graph_bundles: "documents liés",
      part_repository_bundles: "dépôts complets",
      part_long_context: "contexte long",
      part_fine_tuning: "ajustement fin",
      part_reinforcement_learning: "apprentissage par renforcement",
      part_real_folding: "repli réel du contexte",
      sitBlock_data: "Données selon le plan du papier",
      sitBlock_tokenizer: "Tokenizer avec code",
      sitBlock_bench: "Suite de benchmarks du papier",
      sitBlock_trainer: "Entraîneur : étapes de fenêtre, budget fixe, mélange fixe",
      sitBlock_bundles: "Paquets : documents reliés et dépôts complets",
      sitBlock_post_training: "Post-entraînement : contexte long, ajustement fin, apprentissage par récompense",
      tpStepTokenizerRelease: "Publication du tokenizer",
      tpStepTokenizeTdv: "Tokeniser les exemples d'entraînement",
      tpStepTokenizeCorpus: "Tokeniser le corpus",
      tpStepTdvCreate: "Créer la version de données",
      tpStepTdvSeal: "Sceller la version de données",
      apAfterSealLabel: "Continuer automatiquement après le scellement",
      apAfterSealOn: "ON",
      apAfterSealOff: "OFF",
      apAfterSealConfirmOn: "Continuer automatiquement après le scellement ? Le chemin vers le démarrage de l'entraînement se poursuit alors sans pause : contrôle de compatibilité, contrôles GPU et démarrage de l'entraînement.",
      apAfterSealConfirmOff: "S'arrêter de nouveau après le scellement ? Le pilote automatique se met alors en pause pour examen une fois la version des données scellée.",
      apAfterSealTurnedOn: "Le chemin vers le démarrage de l'entraînement se poursuit automatiquement après le scellement.",
      apAfterSealTurnedOff: "Le pilote automatique s'arrête après le scellement.",
      apAfterSealWaiting: "Version des données scellée – le pilote automatique est en pause pour examen.",
      apAfterSealStep: "Examen de la version des données scellée",
      apAfterSealHint: "Après le scellement, toutes les données sont traitées dans le stockage en blocs. Interrupteur coupé, le pilote automatique s'y met en pause pour examen ; activé, le chemin se poursuit automatiquement.",
      tpStepCompat: "Contrôle de compatibilité",
      tpStepVram: "Test VRAM",
      tpStepTrainStart: "Démarrage de l'entraînement",
      tpStepTraining: "Entraînement en cours",
      apSubtitle: "Un interrupteur pour tout le cycle : collecter, traiter et relier les données, générer des exemples, entraîner dès que le plan de données du papier est atteint, évaluer et publier en privé. Chaque blocage est nommé au lieu d'être masqué.",
      apOn: "Autopilote ACTIVÉ",
      apOff: "Autopilote DÉSACTIVÉ",
      apTurnOn: "Activer l'autopilote",
      apTurnOff: "Désactiver l'autopilote",
      apConfirmOn: "Activer le pilote automatique ? Il complète les données en continu jusqu'à la version des données scellée ; ensuite il se met en pause pour examen, sauf si « Continuer automatiquement après le scellement » est activé.",
      apConfirmOff: "Désactiver l'autopilote ? Le travail en cours se termine proprement ; rien n'est jeté.",
      apEnabled: "Autopilote activé",
      apDisabled: "Autopilote désactivé",
      apPause: "Mettre en pause",
      apResume: "Reprendre",
      apResumed: "Autopilote repris",
      apPausedNote: "Autopilote en pause",
      apPausedPill: "en pause",
      apPhaseLabel: "Phase",
      apPhaseSince: "depuis {time}",
      apCycleId: "Cycle",
      apBlockedLabel: "Bloqué",
      apCycleTitle: "Progression du cycle en cours",
      apCycleEmpty: "Aucun cycle actif.",
      colPhase: "Phase",
      colPending: "En attente",
      colRunning: "En cours",
      colDone: "Terminé",
      colFailed: "Échoué",
      thrTitle: "Seuils par capacité",
      thrSubtitle: "À partir de ces volumes, l'autopilote scelle une version de données d'entraînement et lance l'entraînement ; les barres montrent la progression mesurée.",
      thrMet: "atteint",
      thrNotMet: "ouvert",
      thrDefault: "valeur par défaut préremplie",
      thrForeign: 'pas pour le volet choisi',
      staleSince: 'Le worker ne répond pas pour l\'instant — dernier état mesuré du',
      staleHint: 'Le pilote automatique continue ; l\'affichage se rafraîchit dès que le worker répond à nouveau.',
      idxTitle: 'Index vectoriel et déduplication',
      idxSubtitle: 'L\'index HNSW propre au lac pour le liage du graphe et la suppression mesurée des shards de chunks dupliqués.',
      idxConfigured: 'Index configuré',
      idxReachable: 'Index joignable',
      idxPoints: 'Points de l\'index',
      idxBackfill: 'Remplissage depuis la table des embeddings',
      idxBackfillDone: 'terminé',
      idxBackfillOpen: 'en cours / ouvert',
      ddLastPass: 'Dernière passe de déduplication',
      ddChecked: 'actifs vérifiés',
      ddDropped: 'shards dupliqués supprimés',
      ddRows: 'lignes de chunks supprimées',
      ddRemaining: 'candidats restants',
      ddNone: 'pas encore de passe',
      gsTitle: 'Étapes du graphe',
      gsSubtitle: "Les étapes « teacher » du graphe — embedding et extraction d'affirmations — servent la synthèse d'exemples dérivée du graphe ; elles prennent donc les chunks en largeur d'abord à travers les actifs, par ordre de rang : rang 0 les documents du propriétaire et les imports d'outils, rang 1 la masse de savoir expert (science, ingénierie, livres, raisonnement, German Commons, Wikipédia), rang 2 le texte général (Wikisource, Gutenberg, corpus web, transcriptions), rang 3 le code (encodé seulement, jamais soumis à l'extraction d'affirmations). La masse de base atteint le corpus de tokens sans passe « teacher ».",
      gsMeasuredAt: 'Mesuré à',
      gsRanksTitle: 'Ordre des rangs',
      gsRanksEmpty: "Aucun plan de rangs rapporté pour l'instant.",
      gsColRank: 'Rang',
      gsColLabel: 'Classe de source',
      gsColSources: 'Sources',
      gsColAssets: 'Actifs',
      gsColPendingExtract: 'Extraction en attente',
      gsColPendingEmbed: 'Embedding en attente',
      gsRankOwner: "Documents du propriétaire et imports d'outils",
      gsRankExpert: 'Masse de savoir expert',
      gsRankGeneral: 'Texte général',
      gsRankCode: 'Code (embedding seulement)',
      gsRankShort: 'rang {n}',
      gsLoopsTitle: 'Dernier tour de chaque boucle',
      gsColLoop: 'Boucle',
      gsColSource: 'Source',
      gsColChunks: 'Chunks traités',
      gsColClaims: 'Affirmations',
      gsColEdges: 'Arêtes',
      gsColSeconds: 'Secondes',
      gsColLast: 'Dernier tour',
      gsLoopEmbed: 'Embedding',
      gsLoopExtract: "Extraction d'affirmations",
      gsLoopLink: 'Liaison',
      gsUngrounded: '{n} non étayées',
      gsNoRound: 'pas encore de tour',
      gsClaims: 'Affirmations au total',
      gsAssetsWithClaims: 'Actifs avec affirmations',
      gsDangling: 'Nœuds de chunk orphelins',
      gsStuck: 'Actifs bloqués (en traitement sans ingestion active)',
      gsConcurrency: "Parallélisme de l'extraction",
      gsOrphansLast: 'Dernière passe de nettoyage',
      gsOrphansNone: 'pas encore de passe',
      gsOrphansStatusCleaned: 'nettoyé',
      gsOrphansDropped: 'nœuds supprimés',
      gsOrphansRemaining: 'restants',
      gsOrphansHint: "Rien à faire ici : le pilote automatique planifie lui-même une passe de nettoyage bornée tant que des nœuds de chunk sans shard existent. Le résumé montre la dernière passe.",
      thrSamplesBar: "Exemples",
      thrTokensBar: "Tokens (estimés)",
      thrNoMinimum: "mesuré, sans minimum",
      thrEditTitle: "Modifier les seuils",
      thrEditSubtitle: "L'enregistrement remplace tous les seuils intégralement ; les valeurs par défaut préremplies ne valent que tant qu'aucune valeur propre n'est définie ici.",
      thrMinSamples: "Exemples min.",
      thrMinTokens: "Tokens min. (estimés)",
      thrEnabled: "actif",
      thrAdd: "Ajouter une ligne",
      thrSave: "Enregistrer les seuils",
      thrSaved: "Seuils enregistrés",
      thrEmpty: "Aucun seuil défini pour l'instant — sans seuils actifs, l'autopilote ne scelle rien et le signale comme blocage.",
      capability: "Capacité",
      modSignature: "Signature",
      removeRow: "Supprimer",
      budgetsTitle: "Budgets journaliers",
      budgetsSubtitle: "Consommation contre plafond par domaine et par jour — les budgets limitent les appels enseignants et d'embedding.",
      budgetScope: "Domaine",
      budgetDay: "Jour",
      budgetSpent: "Consommé",
      budgetCap: "Plafond",
      budgetsEmpty: "Aucun budget signalé.",
      eventsTitle: "Événements",
      eventsSubtitle: "Ce que l'autopilote a fait ou signalé en dernier, le plus récent d'abord.",
      eventsEmpty: "Pas encore d'événements.",
      storageTitle: "Stockage cloud",
      storageSubtitle: "La connexion au Block Storage et l'initialisation de l'arborescence — répétable sans effets secondaires.",
      connect: "Connecter Block Storage",
      backendLabel: "Backend du stockage froid",
      backendBlockStorage: "Block Storage",
      backendLocal: "Stockage local",
      connectedLabel: "Connexion",
      connectedYes: "connecté",
      connectedNo: "non connecté",
      accountLabel: "Compte",
      signinValidUntil: "Connexion valable jusqu'au",
      oauthClientLabel: "Client OAuth",
      clientConfigured: "configuré",
      clientNotConfigured: "non configuré",
      bootstrapRun: "Initialiser la structure",
      bootstrapDone: "Initialisation exécutée",
      bootstrapReportTitle: "Dernière exécution",
      bootstrapNoRun: "Aucun bootstrap n'a encore été exécuté dans cette session.",
      bootstrapLine: "Dossiers créés : {folders} · fichiers dans le stockage froid : {files} · répétition sans changements : {idempotent}",
      treeTitle: "Arborescence des dossiers",
      treeSubtitle: "L'arborescence est une spécification versionnée : vous définissez ici les dossiers, l'autopilote ne peut qu'ajouter. Les dossiers moteur protégés et les dossiers non vides sont refusés par le moteur avec motif. Dans le Block Storage, les suppressions suivent uniquement des règles fixes, par exemple les anciennes copies de checkpoint (les deux plus récentes restent) ; pendant un téléchargement complet, suppressions et écrasements attendent qu'il se termine.",
      treeActiveVersion: "Version active v{version}",
      treePath: "Chemin",
      treePurpose: "Objet",
      treeCreatedBy: "Créé par",
      treeShards: "Shards",
      treeBytes: "Taille",
      treeActions: "Actions",
      treeRetire: "Retirer",
      treeRetired: "Dossier retiré",
      treeAddFolder: "Ajouter un dossier",
      treeFolderAdded: "Dossier créé",
      treeVersionsTitle: "Versions",
      treeEmpty: "Aucun dossier défini pour l'instant.",
      treePlanned: "Planifié — spécification d'arborescence v{version}",
      treeFiles: "Fichiers",
      treeSizesMeasured: "Tailles mesurées {measured} ; les dossiers que le catalogue ne recense pas ont été comptés dans le Block Storage pour la dernière fois {walked}. 1 GB = 10⁹ octets.",
      treeSizesNoWalk: "Tailles mesurées {measured} ; les dossiers que le catalogue ne recense pas n'ont pas encore été comptés. 1 GB = 10⁹ octets.",
      treeExpand: "Afficher {count} sous-dossiers",
      treeCollapse: "Masquer les sous-dossiers",
      treeShowMore: "Afficher {count} dossiers de plus",
      treeSourceCatalog: "Selon le catalogue : sont comptés les objets réellement présents dans le Block Storage",
      treeSourceWalk: "Compté lors du parcours du Block Storage",
      bsUsageTitle: "Espace du Block Storage",
      bsUsageSubtitle: "Espace occupé, limite et espace libre du compte Block Storage, ainsi que la part du data lake ; les valeurs datent au plus de dix minutes. 1 GB = 10⁹ octets.",
      bsUsed: "Occupé",
      bsLimit: "Limite",
      bsFree: "Libre",
      bsNoLimit: "sans limite fixe",
      bsTrash: "Dans la corbeille",
      bsLake: "Dont data lake",
      bsLakeLine: "{size} dans {files} fichiers · {share} de l'espace occupé",
      bsMeasuredAt: "Mesuré",
      bsNotConnected: "Le Block Storage n'est pas connecté ; l'espace apparaît dès que la connexion est établie.",
      bsBarLake: "Data lake",
      bsBarOther: "Reste du compte",
      bsDlTitle: "Téléchargement complet",
      bsDlSubtitle: "Télécharge tout le Block Storage fichier par fichier dans la même arborescence, sans archive. Tant qu'il est en cours, le mode protection s'applique : les suppressions et écrasements des fichiers recensés attendent qu'il se termine ; les nouveaux fichiers continuent d'être écrits et ne font pas partie de ce téléchargement. Un entraînement en cours n'est jamais retardé.",
      bsDlButton: "Télécharger tout le Block Storage",
      bsDlFolderHint: "Vous choisissez une seule fois un dossier cible ; les sous-dossiers y sont créés. Les fichiers déjà complets sont ignorés, les fichiers interrompus reprennent à partir de leur longueur.",
      bsDlScriptHint: "Ce navigateur ne peut pas écrire de dossiers. Vous recevez un script de téléchargement qui crée la même arborescence et télécharge chaque fichier avec reprise possible.",
      bsDlWindowsNames: "Les caractères que Windows n'autorise pas dans les noms (comme « > ») figurent dans le dossier cible sous forme de code %, par exemple %3E.",
      bsDlActiveNote: "Un téléchargement est en cours depuis {time}. Le bouton ci-dessus le poursuit dans ce navigateur ; les fichiers complets sont ignorés.",
      bsDlBuilding: "La liste des fichiers est en cours de création : {files} fichiers jusqu'ici, {size}.",
      bsDlManifest: "Chargement de la liste des fichiers : {done} sur {total} entrées.",
      bsDlFolder: "Dossier cible",
      bsDlFiles: "Fichiers",
      bsDlData: "Données",
      bsDlOf: "{done} sur {total}",
      bsDlRate: "Débit",
      bsDlEta: "Temps restant",
      bsDlEtaUnknown: "en cours d'estimation",
      bsDlCurrent: "En cours de chargement",
      bsDlSkipped: "{count} déjà complets, ignorés",
      bsDlFailed: "{count} fichiers en échec",
      bsDlPausedNote: "En pause. À la reprise, les fichiers entamés continuent à partir de leur longueur ; le mode protection reste actif tant que cette page est ouverte.",
      bsDlPause: "Mettre en pause",
      bsDlContinue: "Reprendre",
      bsDlRetryFailed: "Recharger les fichiers en échec",
      bsDlFinish: "Terminer",
      bsDlStop: "Arrêter",
      bsDlStateBuilding: "liste des fichiers en préparation",
      bsDlStateRunning: "téléchargement en cours",
      bsDlStatePaused: "en pause",
      bsDlStateIncomplete: "incomplet",
      bsDlStateScript: "script prêt",
      bsDlStateFinished: "terminé",
      bsDlStateStopped: "arrêté",
      bsDlStateActive: "actif",
      bsDlFinished: "Les {files} fichiers ({size}) sont tous dans le dossier cible ; le téléchargement est terminé.",
      bsDlFinishedNote: "Le téléchargement est terminé ; les suppressions et écrasements retenus s'exécutent maintenant.",
      bsDlStopped: "Le téléchargement est arrêté ; les suppressions et écrasements retenus s'exécutent maintenant. Les fichiers déjà téléchargés sont conservés.",
      bsDlEnded: "Le serveur a mis fin au téléchargement, par exemple après trente minutes sans signe de vie. Un nouveau clic le relance ; les fichiers complets sont ignorés.",
      bsDlSession: "La connexion a expiré. Veuillez vous reconnecter ; ensuite, le bouton ci-dessus poursuit le téléchargement.",
      bsDlDiskFull: "Le dossier cible n'a plus d'espace libre. Libérez de la place, puis reprenez.",
      bsDlPickFailed: "Le dossier cible n'a pas pu être ouvert.",
      bsDlScriptPosix: "Script pour Linux et macOS",
      bsDlScriptWindows: "Script pour Windows",
      bsDlScriptRun: "Enregistrez le script dans le dossier cible et lancez-le là : sous Windows par un double-clic sur le fichier .cmd ou depuis l'invite de commandes, sous Linux et macOS dans un terminal avec « sh <fichier> ».",
      bsDlScriptKeyValid: "La clé du script est valable jusqu'au {time}, uniquement pour ce téléchargement et uniquement en lecture.",
      bsDlScriptHeartbeat: "Tant que cette page est ouverte, elle signale au serveur que le téléchargement est en cours. Cliquez sur « Terminer » une fois le script achevé.",
      bsDlProtection: "Mode protection",
      bsDlProtectionState: "État",
      bsDlProtectionOn: "actif depuis {time}",
      bsDlProtectionOff: "inactif",
      bsDlScope: "Étendue du téléchargement",
      bsDlScopeValue: "{files} fichiers, {size}",
      bsDlDeferredDeletes: "Suppressions retenues",
      bsDlDeferredOverwrites: "Écrasements retenus",
      bsDlAddedSince: "Ajoutés depuis le début",
      bsDlLastActivity: "Dernier signe de vie",
      acqTitle: "Sources de données",
      acqSubtitle: "Sources organisées sous licence ouverte : pour chacune, la licence, l'évaluation de protection des données, la langue, la modalité, l'objectif en octets et la progression mesurée. Les sources désactivées nomment leur raison au lieu d'être silencieusement absentes.",
      acqGdprNote: "Principe RGPD : les données d'entraînement ne sont admises que depuis des sources sous licence ouverte avec une évaluation de protection des données documentée ; les données de la boîte d'entrée passent un nettoyage PII avant la création d'exemples (le compteur « nettoyé PII » le montre).",
      acqSource: "Source",
      acqModality: "Modalité · langue",
      acqLicense: "Licence",
      acqProtection: "Protection des données",
      acqProgress: "Progression",
      acqDocs: "{count} fichiers/objets reçus",
      acqTargetReached: "objectif atteint",
      acqExhausted: "source épuisée (le listing ne fournit plus rien)",
      acqEnabledPill: "active",
      acqWaitingBuffer: "en attente : tampon plein, le téléversement rattrape",
      acqDisabledPill: "désactivée",
      acqEnable: "Activer",
      acqDisable: "Désactiver",
      acqEnabledMsg: "Source activée",
      acqDisabledMsg: "Source désactivée",
      acqTargetLabel: "Objectif (Go)",
      acqSetTarget: "Enregistrer l'objectif",
      acqTargetSaved: "Objectif enregistré",
      acqEmpty: "Aucune source enregistrée pour l'instant.",
      balanceTitle: "Équilibre linguistique allemand/anglais",
      balanceSubtitle: "Octets téléchargés par modalité et par langue — pour les sources de départ, l'allemand ne doit pas rester derrière l'anglais.",
      balanceEmpty: "Pas encore de mesures.",
      modText: "Texte",
      modAudio: "Audio",
      modImage: "Image",
      modVideo: "Vidéo",
      prepTitle: "Prétraitement",
      prepSubtitle: "Étapes du pipeline comptées, du document brut enregistré à l'exemple d'entraînement — chaque chiffre vient du catalogue ; échecs et éléments non pris en charge sont nommés.",
      prepRegistered: "enregistrés",
      prepScrubbed: "nettoyés PII",
      prepChunked: "découpés",
      prepEmbedded: "encodés",
      prepExtracted: "extraits",
      prepLinked: "reliés",
      prepSamples: "exemples",
      prepByLang: "Par langue",
      prepUnsupported: "Non pris en charge",
      prepAwaiting: "En attente d'une étape",
      prepFailures: "Échecs",
      inboxTitle: "Boîte d'entrée des données brutes",
      assetWhat: "Contenu",
      assetFromSource: "de la source {source}",
      assetFromUpload: "téléversé manuellement",
      mediaParquet: "Données tabulaires (Parquet)",
      treeShardsHint: "Les shards sont les paquets de données Parquet du catalogue : chaque ligne est un paquet avec origine, langue et usage — la colonne « usage » dit ce que contient un dossier.",
      mediaWords: {
        text: "Texte",
        audio: "Audio",
        video: "Vidéo",
        image: "Image",
        application: "Fichier",
      },
      inboxSubtitle: "Confier ses propres données brutes au lake : téléverser ici ou déposer directement dans le dossier cloud raw/inbox/. Le rapprochement enregistre chaque fichier ; « Traiter maintenant » lance le même chemin que l'autopilote parcourt seul.",
      uploadButton: "Téléverser un fichier",
      uploadHint: "Jusqu'à 512 Mo par fichier. Les téléversements arrivent dans le stockage froid et sont découpés, encodés en embeddings et reliés au graphe de connaissances lors du traitement.",
      uploadTooLarge: "Le fichier dépasse 512 Mo.",
      uploadDone: "Fichier accepté",
      processNow: "Traiter maintenant",
      processStarted: "Traitement lancé",
      reconcileNow: "Rapprocher le dossier cloud",
      reconcileDone: "Rapprochement exécuté",
      unprocessedCount: "{count} non traité(s)",
      inboxEmpty: "La boîte d'entrée est vide.",
      assetName: "Fichier",
      assetType: "Type",
      assetSize: "Taille",
      assetState: "État",
      assetLang: "Langue",
      assetRegistered: "Enregistré",
      assetStates: {
        raw_stored: "données brutes stockées",
        awaiting_stt: "en attente de reconnaissance vocale",
        awaiting_content_fetch: "en attente du contenu derrière l'adresse",
        awaiting_image_codec: "en attente du codec image",
        awaiting_audio_codec: "en attente du codec audio",
        awaiting_video_codec: "en attente du codec vidéo",
        chunked: "découpé et dans le graphe",
        processed: "traité",
        registered: "enregistré",
        queued: "en attente",
        processing: "en traitement",
        ingested: "intégré",
        linked: "relié",
        unsupported: "non pris en charge",
        failed: "échoué",
      },
      graphTitle: "Graphe de connaissances",
      graphSubtitle: "Le corpus brut relié : nœuds et arêtes comptés depuis le catalogue — les exemples d'entraînement naissent de ces liens.",
      graphEmbedded: "Nœuds encodés (embeddings)",
      graphModel: "Modèle d'embedding",
      graphClusters: "Clusters",
      graphAssetsLinked: "Données brutes reliées",
      graphLastLink: "Dernière liaison",
      graphNodesTitle: "Nœuds par type",
      graphEdgesTitle: "Arêtes par type",
      graphEmpty: "Le graphe est encore vide — il naît avec le premier fichier traité.",
      kindCol: "Type",
      countCol: "Nombre",
      neighborsTitle: "Voisins d'un nœud",
      nodeIdLabel: "ID du nœud",
      neighborsRun: "Récupérer les voisins",
      neighborsEmpty: "Aucun voisin trouvé.",
      nodeCol: "Nœud",
      edgeKindCol: "Arête",
      weightCol: "Poids",
      gapTitle: "Matrice de couverture et d'écarts",
      gapSubtitle: "Inventaire mesuré face aux cibles de mélange configurées par capacité, signature et niveau — une vue SQL sur le catalogue, jamais codée en dur.",
      tier: "Niveau",
      gapHave: "Réel",
      gapTarget: "Cible",
      gapWeight: "Poids",
      gapPriority: "Priorité",
      targetsTitle: "Définir des cibles de mélange",
      targetsSubtitle: "Les cibles portent leur auteur et leur horodatage ; sans cibles, la matrice montre honnêtement l'état vide.",
      addTargetRow: "Ajouter une ligne",
      saveTargets: "Enregistrer les cibles",
      targetsSaved: "Cibles enregistrées",
      statusCol: "Statut",
      tdvTitle: "Version de données scellée",
      tdvSubtitle: "La version de données est immuable et composée de shards scellés ; une nouvelle remplace la précédente.",
      createTdv: "Créer un brouillon de TDV",
      tdvCreated: "Brouillon de TDV créé",
      tdvId: "TDV",
      tdvName: "Nom",
      tdvMembers: "Membres",
      tdvCreatedAt: "Créée",
      tdvSealedAt: "Scellée",
      tdvStatusDraft: "brouillon",
      tdvStatusSealed: "scellée",
      sealTdv: "Sceller",
      tdvSealed: "TDV scellée",
      tdvEmpty: "Pas encore de Train Data Version — elle se compose à partir de shards scellés.",
      compatTitle: "Contrôle de compatibilité architecture et données",
      compatSubtitle: "Règles R1–R12 sur deux documents lisibles par machine ; le tableau de bord affiche le rapport stocké du moteur et ne calcule aucun verdict propre.",
      compatAllGreen: "ALL-GREEN",
      compatNotGreen: "pas ALL-GREEN",
      compatRun: "Exécuter le contrôle",
      compatChecked: "Contrôle exécuté",
      compatSelectTdv: "Sélectionner une TDV dans la liste ci-dessus pour voir son rapport.",
      compatNoReport: "Aucun rapport de compatibilité stocké n'existe encore pour cette TDV.",
      compatDraftNote: "L'interface de données de l'architecture est un brouillon — les artefacts de tokenizer et de codec n'existent pas encore ; le contrôle s'active avec la première publication du tokenizer et la première TDV scellée.",
      compatRule: "Règle",
      compatTitleCol: "Titre",
      compatKind: "Type",
      compatEvidence: "Valeurs comparées (preuves)",
      kindHard: "stricte",
      kindWarn: "avertissement",
      reportsTitle: "Rapports stockés",
      reportsEmpty: "Aucun rapport de compatibilité stocké pour l'instant.",
      phaseLabel: "Phase d'entraînement",
      phaseA: "Phase A — préparation et évolution",
      phaseB: "Phase B — entraînement en cours, architecture gelée",
      checklistTitle: "Préparation à l'entraînement (liste de contrôle phase A)",
      checklistSubtitle: "Conditions calculées en direct ; le démarrage reste bloqué tant que chaque point n'est pas vert, et chaque point non rempli est nommé.",
      checklistReady: "prêt",
      checklistUnmet: "{count} points non remplis",
      checklistUnavailable: "La liste de contrôle est injoignable.",
      itemSatisfied: "rempli",
      itemUnsatisfied: "non rempli",
      startTraining: "Démarrer la phase B",
      strandTitle: 'Volet d\'entraînement',
      strandSubtitle: 'Quel volet du modèle s\'entraîne dès que toutes les conditions sont réunies ; le volet non choisi continue de préparer les données mais ne démarre jamais.',
      strandSelectedBadge: 'sélectionné',
      strandExplain: 'L\'autopilote entraîne {selected}. {other} continue de collecter et de préparer, mais ne démarre pas tant qu\'il n\'est pas sélectionné.',
      strandSwitched: 'Sélection enregistrée.',
      strandSwitchFailed: 'Échec du changement.',
      strandUnavailable: 'Ce backend ne fournit pas encore de volets ; le sélecteur apparaîtra après le prochain déploiement du cœur.',
      trainingStarted: "Phase B démarrée",
      startBlocked: "Démarrage bloqué — non rempli : {items}",
      selectedTdvLabel: "Version de données choisie",
      computedAt: "Calculé",
      runsTitle: "Entraînements",
      runsSubtitle: "Uniquement des exécutions réelles issues du catalogue ; il n'existe aucun entraînement simulé.",
      runId: "Exécution",
      archVersion: "Architecture",
      presetCol: "Preset",
      seqLenCol: "Longueur de séquence",
      stepCol: "Pas",
      lossCol: "Loss",
      runStarted: "Démarrée",
      runFinished: "Terminée",
      runsEmpty: "Aucun entraînement pour l'instant.",
      abortRun: "Interrompre",
      confirmAbort: "Interrompre cette exécution d'entraînement ?",
      runAborted: "Interruption demandée",
      benchLink: "Benchmark",
      benchTitle: "Rapports de benchmark",
      benchSubtitle: "La suite gelée et versionnée s'exécute automatiquement après chaque entraînement ; chaque rapport est stocké dans le lake et affiché ici.",
      benchEmpty: "Pas encore de rapport de benchmark.",
      suiteVersion: "Suite",
      benchOpen: "Ouvrir",
      benchReportFor: "Rapport de benchmark pour l'exécution {run}",
      benchNoMarkdown: "Ce rapport ne porte pas de document rendu ; les résultats bruts figurent ci-dessous.",
      exportsTitle: "Exports",
      exportsSubtitle: "Les téléchargements n'existent que pour les exports d'entraînements réels terminés.",
      exportId: "Export",
      exportSize: "Taille",
      exportSha: "SHA-256",
      download: "Télécharger",
      exportsEmpty: "Aucun export pour l'instant — il ne naît que d'un entraînement réel terminé.",
      hfTitle: "Publications HuggingFace",
      hfSubtitle: "Chaque téléversement est privé ; la visibilité est vérifiée via l'API après le téléversement. Un résultat non privé est un état d'erreur qui arrête le cycle.",
      hfEmpty: "Pas encore de publication.",
      hfRepo: "Dépôt",
      hfState: "État",
      hfVisibility: "Visibilité",
      hfPrivateVerified: "privé — vérifié",
      hfUnverified: "pas encore vérifié",
      hfVerifiedAt: "Vérifié",
      connectTitle: "Connecter Block Storage",
      connectSubtitle: "Connexion via la fenêtre de connexion du fournisseur de stockage ; le stockage se lie au compte qui confirme.",
      webConnectStart: "Se connecter avec le fournisseur de stockage",
      webConnectWaiting: "En attente de la confirmation dans la fenêtre de connexion du fournisseur de stockage…",
      webConnectHint: "Après la confirmation, le stockage se connecte automatiquement ; cette boîte se met à jour seule.",
      publicIdentity: "Identité d\'application publique (rclone, quota partagé)",
      publicIdentityNote: "La fenêtre de connexion du fournisseur de stockage affiche « rclone » comme application demandeuse — l\'identité publiquement partagée ; un client ID propre (GDRIVE_OAUTH_CLIENT_ID) la remplace à tout moment.",
      manualHint: "Après la confirmation, le navigateur affiche une page localhost inaccessible. Copiez la valeur du paramètre code= depuis la barre d\'adresse et collez-la ici (coller l\'adresse entière fonctionne aussi).",
      manualCodeLabel: "Code d\'autorisation",
      manualSubmit: "Valider le code",
      deviceInstead: "Utiliser plutôt un code d\'appareil",
      licenseAcceptLink: "Confirmer la licence sur Hugging Face",
      deviceFlowTitle: "Connecter Block Storage (device flow)",
      deviceFlowSubtitle: "Le moteur lance le flux de connexion du fournisseur pour appareils ; la confirmation se fait sur un second appareil, interrogée à intervalles bornés.",
      deviceFlowStart: "Démarrer le flux de connexion",
      deviceFlowCode: "Code d'appareil",
      deviceFlowOpenUrl: "Ouvrir la page de confirmation",
      deviceFlowWaiting: "En attente de confirmation — l'interrogation suit l'intervalle prescrit par le fournisseur.",
      deviceFlowAuthorized: "Connecté",
      deviceFlowExpired: "Le code d'appareil a expiré — relancer le flux de connexion.",
      readinessTitle: "Préparation à l'entraînement",
      readinessSubtitle: "Le chemin mesuré vers le premier entraînement, étape par étape.",
      readinessCounter: "{green} sur {total} remplies",
      readinessReady: "Prêt pour l'entraînement",
      unblockLabel: "Prochaine étape",
      readinessUnavailable: "L'aperçu de préparation n'est pas encore déployé côté backend. Dès que le point de terminaison sera actif, l'état mesuré apparaîtra ici.",
      stageStates: {
        ok: "remplie",
        active: "en cours",
        waiting: "en attente",
        blocked: "bloquée",
      },
    },
    gt: {
      loading: '…',
      unavailable: 'indisponible',
      equilibrium: 'État de fonctionnement optimal atteint : toutes les demandes ont reçu une réponse, tous les transferts de tâches ont été traités et les redondances ont été évitées.',
      standby: 'en veille',
      defTitle: 'Coordination Opérationnelle d\'Équipe & Indicateurs de Performance',
      defSubtitle: 'Mesure de la qualité opérationnelle de communication et de transfert de tous les rôles IA : priorité aux résultats vérifiés plutôt qu\'à l\'activité improductive.',
      defPlayers: 'Rôles & Systèmes Impliqués',
      defPlayersText: 'Les dix rôles IA spécialisés avec leurs bots Webex ainsi que les décideurs humains qui définissent les missions et les directives.',
      defStrategies: 'Principes de Communication & d\'Exécution',
      defStrategiesText: 'Réponse directe aux sollicitations, transferts de tâches complets et sans ambiguïté, prévention des redondances et clôture rigoureuse des lots de travail ouverts.',
      defPayoff: 'Contribution Opérationnelle Nette (Utilité Nette)',
      defPayoffText: 'Lots de travail clôturés, transferts traités avec succès et demandes répondues — moins les pertes par friction (redondances, transferts non traités, demandes sans réponse).',
      defEquilibrium: 'État Opérationnel Optimal (Équilibre de Coordination)',
      defEquilibriumText: 'État cible de collaboration : chaque demande reçoit une réponse dans les délais, chaque transfert est pris en charge, aucune information n\'est envoyée deux fois et aucun lot de travail ne reste en souffrance.',
      playersTitle: 'Synthèse des Performances par Rôle (Positions)',
      playersSubtitle: 'Indicateurs opérationnels de communication et de livraison par rôle : contributions métier et transferts (7 derniers jours) ainsi que réunions et lots de travail clôturés (30 derniers jours).',
      playersHint: 'Utilité nette = 3 × lots de travail clôturés + transferts traités − pertes par friction (les transferts non traités comptent double). Une valeur négative signale un besoin de coordination.',
      player: 'Rôle / Position',
      contributions: 'Contributions',
      meetingTurns: 'Réunions',
      handovers: 'Passations',
      consumedShort: 'traitées',
      refusedShort: 'refusées',
      delivery: 'Livraison',
      pausedTurns: 'Tours en pause',
      pausedTurnsHint: 'Tours conservés dans la boîte aux lettres du collègue parce que les modèles n’ont pas pu les servir à ce moment-là. Ce ne sont pas des passations.',
      closedOpen: 'clos / ouverts',
      noise: 'Perte par friction',
      utility: 'Contribution nette',
      meetingsLine: '{held} réunions, {turns} prises de parole, {u} interpellations sans réponse (30 jours).',
      interactionsTitle: 'Transferts de Tâches entre Rôles (Matrice de Handover)',
      interactionsSubtitle: 'Transferts de tâches dirigés entre boîtes aux lettres (7 derniers jours) : volume, délai d\'acheminement ainsi que transferts traités et refusés.',
      interactionsHint: 'Un transfert de tâche n\'est considéré comme achevé qu\'après traitement par le destinataire ; les transferts refusés ou non traités sont signalés comme écarts de processus.',
      interactionsEmpty: 'Aucune passation dans la fenêtre.',
      from: 'De',
      to: 'À',
      messages: 'Messages',
      consumed: 'traitées',
      refused: 'refusées',
      deviationsTitle: 'Écarts de Processus & Goulets d\'Étranglement',
      deviationsSubtitle: 'Défauts de coordination actuels : demandes sans réponse, transferts non traités, contributions redondantes ou lots de travail bloqués.',
      dev_unanswered_question: 'Demande sans réponse (délai dépassé)',
      dev_dead_air: 'Transfert de tâche sans retour',
      dev_repetition: 'Répétition en réunion',
      dev_meeting_unanswered: 'Sollicitation directe sans réponse',
      dev_work_blocked: 'Travail bloqué',
      dev_handover_hop_budget_reached: 'Budget de sauts de passation dépassé',
      dev_commitment_unkept: 'Engagement de sprint non tenu',
      devWithheld: 'retenu',
      devRepetition: 'répétition',
      devDeadAir: 'transfert non traité',
      devMeetingUnanswered: 'sans réponse',
      effectiveThresholdCol: 'Seuil eff.',
      excessHopsLabel: 'Sauts de passation excédentaires',
      timeTitle: 'Temps de Cycle & Comparaison de Productivité (IA vs traitement manuel)',
      timeSubtitle: 'Durée réelle de traitement IA des tâches de développement achevées comparée à la charge de travail manuelle estimée.',
      timeHint: 'Valeurs de référence analytiques pour l\'estimation de charge ; configurables par la direction.',
      avgCycle: 'Cycle IA moyen',
      fromTasks: 'sur {n} tâches',
      speedup: 'Accélération',
      speedupHint: '{h} heures humaines supposées par pièce',
      humanDelivered: 'Jours-homme livrés',
      humanDays: 'jours-homme',
      forecast: 'Prévision du travail ouvert : {d} jours-homme',
      sizes: 'Tailles',
      sizeSmall: 'petites',
      sizeMedium: 'moyennes',
      sizeLarge: 'grandes',
      scrumTitle: 'Scrum',
      scrumSubtitle: 'Le sprint, ses story points et la vélocité, lus dans les données de la société',
      sprintLabel: 'Sprint {n}',
      ends: 'se termine',
      committedPts: 'Points engagés',
      deliveredPts: 'Points livrés',
      remainingPts: 'Points restants',
      burndownTitle: 'Burndown (points restants par jour)',
      velocityTitle: 'Vélocité des sprints clos',
      predictability: 'prévisibilité',
      forecastLine: 'Vélocité glissante {v} points par sprint · backlog {b} points ≈ {s} sprints',
      noSprint: 'Aucun sprint en cours ; la prochaine planification en ouvre un.',
      noItems: 'Rien n\'est encore engagé ; le sprint prend ce que les personnes apportent.',
      colItem: 'Élément',
      colOwner: 'Responsable',
      colPoints: 'Points',
      colState: 'État',
      itemDone: 'livré',
      itemOpen: 'ouvert',
      unestimated: 'non estimé',
      addedBy: 'ajouté par {who}',
      setGoal: 'Objectif du sprint',
      sprintDaysLabel: 'Durée du sprint (jours)',
      save: 'Enregistrer',
      endSprint: 'Terminer le sprint maintenant',
      confirmEndSprint: 'Terminer le sprint maintenant ? La revue, la rétrospective et la prochaine planification se tiennent aussitôt.',
      planNow: 'Tenir la première planification maintenant',
      confirmPlanNow: 'Tenir la planification du sprint maintenant ? Elle ouvre le premier sprint dans pAIoneer-scrum.',
      sprintPointsCol: 'Points du sprint',
      ceremonySpaceLabel: 'Espace de cérémonie',
      scrumOfScrums: 'Tenir le Scrum of Scrums',
      confirmScrumOfScrums: 'Tenir le Scrum of Scrums entre toutes les Business Units maintenant ?',
      lastScrumOfScrumsTitle: 'Dernier Scrum of Scrums',
      escalatedImpedimentsTitle: 'Obstacles escaladés',
      unitBreakdownTitle: 'Répartition du sprint par Business Unit',
      colUnit: 'Business Unit',
      colWip: 'Travail en cours',
      colImpediments: 'Obstacles',
    },
    nav: {
      groups: {
        gametheory: 'Coordination d\'équipe & Scrum',
        demos: 'Aperçus en direct',
        sovereign: 'LLM souverain',
        today: 'Vue d\'ensemble & Poste de pilotage',
        organisation: 'Organisation',
        work: 'Travail',
        communication: 'Communication',
        memory: 'Mémoire',
        platform: 'Plateforme',
        products: 'Produits',
        identity: 'Identité',
      },
      pages: {
        gametheory: 'Coordination d\'équipe & Scrum',
        demos: 'Aperçus en direct',
        llm: 'Architecture LLM — article',
        training: 'Data Lake & Entraînement IA',
        today: 'Vue d\'ensemble & Poste de pilotage',
        work: 'Lots de travail et projets',
        coding: 'Tâches de programmation',
        gitlab: 'GitLab & Builds d\'images',
        agents: 'Agents et conceptions',
        research: 'Recherches',
        webex: 'Espaces Webex',
        mailboxes: 'Boîtes aux lettres',
        conversations: 'Appels et conversations',
        meetings: 'Réunions',
        engines: 'Moteurs IA & GPU',
        usage: 'Consommation et budgets',
        workloads: 'Services conteneurisés',
        orchestrator: 'Orchestrateur MCP Veridion',
      },
      sections: {
        demos: {
          previews: 'Aperçus en direct',
        },
        llm: {
          paper: 'Article',
          monitoring: 'Surveillance',
        },
        training: {
          autopilot: "Autopilote",
          storage: "Stockage cloud & arborescence",
          acquisition: "Acquisition & prétraitement",
          data: "Données & graphe de connaissances",
          training: "Entraînement & publication",
        },
        platform: {
          nodes: 'Nœuds du cluster',
          events: 'Événements',
        },
        smtm: {
          runtime: 'Pilotage du runtime',
          prediction: 'Pilotage des prévisions',
          status: 'État des données',
          reporting: 'Signaux',
          training: 'Modèles',
          console: 'Console d\'entraînement',
        },
        agentic: {
          overview: 'Vue d\'ensemble',
          tools: 'Outils',
          mcp: 'Serveurs MCP',
          activity: 'Activité',
        },
        'company-memory': {
          content: 'Contenu',
          search: 'Recherche et points de situation',
          facts: 'Faits',
          entity: 'Entités',
          remember: 'Enregistrer',
          audit: 'Journal d\'audit',
          console: 'Console de requêtes',
          stores: 'Stockages',
          graph: 'Graphe de connaissances',
          day: 'Journée',
            bubbles: 'Domaines de connaissances métier & Recherche'
        },
        organisation: {
          chart: 'Organigramme',
          colleagues: 'Collègues IA et boîtes aux lettres',
          voices: 'Voix',
          people: 'Personnes et espaces',
          approvals: 'Validations et plannings',
          edit: 'Modifier l\'organisation',
        },
        work: {
          items: 'Lots de travail',
          projects: 'Projets en développement',
        },
        gitlab: {
          gitlab: 'GitLab',
          builds: 'Builds d\'images',
        },
        agents: {
          agents: 'Agents',
          designs: 'Conceptions d\'agents',
          definitions: 'Définitions',
        },
        usage: {
          identities: 'Par identité',
          budgets: 'Budgets de jetons',
          company: 'Instance de l\'entreprise',
          smtm: 'Veridion SMTM',
        },
        orchestrator: {
          runtime: 'Exécution',
          mcp: 'Serveurs MCP',
          tools: 'Outils',
          activity: 'Activité',
        },
      },
      attentionTitle: 'Action requise',
      attentionSubtitle: 'États de tous les domaines qui demandent une intervention. Un clic ouvre la section.',
      attentionNone: 'Aucune action requise.',
      stateTitle: 'État de fonctionnement',
      none: 'aucun',
      readyOf: '{ready} sur {total} prêts',
      connectedOf: '{connected} sur {total} connectés',
      registeredOf: '{registered} sur {total} enregistrés',
      showMore: 'Afficher plus',
      shownOf: '{shown} sur {total}',
      expand: 'Déplier',
      collapse: 'Replier',
      service: 'Service',
      serviceLinks: 'Liens',
      controlsTitle: 'Commandes de Veridion Core',
      confirmRemove: 'Supprimer {what} ?',
      companyIdentitiesTitle: 'Identités de passerelle de l\'instance de l\'entreprise',
      companyIdentitiesSubtitle: 'Les jetons de l\'orchestrateur et de Veridion Core dans la fenêtre courante de la passerelle, chaque identité avec son budget.',
      conversationsTitle: 'Conversations depuis le tableau de bord',
      conversationsSubtitle: 'Par collègue IA, les conversations écrites depuis le tableau de bord ; écrire et appeler ouvrent une boîte de dialogue au-dessus de la page.',
      conversationCount: 'Messages',
      conversationLastWritten: 'Dernier message',
      conversationLastAnswered: 'Dernière réponse',
      exchangesTitle: 'Messages et réponses',
      exchangesSubtitle: 'Chaque message du tableau de bord avec la réponse du collègue IA, le plus récent en premier.',
      conversationMessage: 'Message',
      conversationAnswer: 'Réponse',
      today: {
        wordTitle: 'Directive de direction active',
        wordNone: 'Aucune directive de direction ouverte n\'est actuellement enregistrée.',
        sinceTitle: 'Événements depuis la dernière consultation',
        sinceState: 'depuis {time}',
        workTitle: 'Tâches actives & Responsabilités',
        workNone: 'Aucun lot de travail n\'est en cours.',
        nextMeeting: 'Prochaine réunion',
        lastMeeting: 'Dernière réunion',
      },
      work: {
        title: 'Lots de travail',
        subtitle: 'Chaque lot de travail ouvert de la mémoire de l\'entreprise avec son responsable, son état, sa priorité, son échéance et les résultats de ses scénarios ; le titre l\'ouvre dans le graphe.',
        item: 'Lot de travail',
        kind: 'Type',
        owner: 'Responsable',
        status: 'État',
        priority: 'Priorité',
        due: 'Échéance',
        scenarios: 'Scénarios',
        updated: 'Mis à jour',
        none: 'Aucun lot de travail ouvert.',
        all: 'Tous les responsables',
      },
      meetings: {
        subtitle: 'Les réunions des collègues IA telles que Veridion Core les enregistre : créneau, résumé et les engagements devenus du travail.',
        slot: 'Créneau',
        kind: 'Type',
        started: 'Début',
        ended: 'Fin',
        summary: 'Résumé',
        commitments: 'Engagements',
        hold: 'Tenir une réunion maintenant',
        held: 'La réunion a été convoquée.',
        notHeld: 'Une réunion est en cours ou a eu lieu dans la dernière demi-heure.',
        holdFailed: 'La réunion n\'a pas pu être convoquée',
        none: 'Aucune réunion enregistrée pour l\'instant.',
      },
      research: {
        title: 'Recherches',
        subtitle: 'Les recherches des collègues IA issues de la chronologie de l\'entreprise, les plus récentes en premier.',
      },
      attention: {
        toneError: 'Panne',
        toneWarning: 'Avis',
        state: {
          platform: '{ready} workloads sur {workloads} prêts, {nodes} nœuds sur {total} prêts, {restarts} redémarrages.',
          gateway: '{state} ; {models} modèles routés, {backends} backends de service sur {total} prêts.',
          engine: '{engine} : {running} en cours, {waiting} en attente',
          usage: '{tokens} jetons sur {identities} identités dans la fenêtre {window}.',
          smtm: 'Porte de prévision {gate}, reconstruction {rebuild} ; {online} modèles sur {models} en ligne, {failed} en échec.',
          smtmSignals: '{open} signaux ouverts, {resolved} résolus, {failed} livraisons en échec.',
          smtmVeridion: '{connected} serveurs MCP sur {servers} connectés.',
          company: 'Orchestrateur {status} ; {ready} workloads sur {workloads} prêts ; Veridion Core {core} ; {agents} agents en cours, {waiting} en attente.',
          companyWebex: '{registered} webhooks de bots sur {bots} enregistrés.',
          approvals: '{approvals} validations ouvertes ; {tasks} tâches de codage attendent une personne ou une revue.',
          sessions: '{users} utilisateurs connectés, {sessions} sessions, {mfa} vérifiées, {total} comptes.',
          mail: 'SMTP {state}.',
        },
        platformUnreadable: 'L\'état de la plateforme n\'est pas lisible.',
        nodeNotReady: 'Le nœud {name} n\'est pas prêt.',
        nodePressure: 'Le nœud {name} signale une saturation : {pressure}.',
        workloadDown: '{name} ({namespace}) : {ready} sur {desired} prêts.',
        gatewayNotProgrammed: 'La passerelle IA n\'est pas programmée.',
        smtmGateClosed: 'La porte des prévisions est fermée.',
        smtmRebuild: 'Une reconstruction est marquée.',
        smtmHint: 'État des données : {hint}.',
        smtmDeliveryFailed: '{count} livraisons de signaux ont échoué.',
        smtmModelsFailed: '{count} modèles signalent une erreur.',
        mcpUnreachable: 'Le serveur MCP {server} de {instance} est injoignable.',
        partUnavailable: 'Veridion pAIoneer Labs GmbH : {part} ne répond pas.',
        parts: {
          orchestrator: 'l\'orchestrateur',
          webex: 'le pont Webex',
          knowledge: 'la base de connaissances',
          core: 'Veridion Core',
          mcp: 'les serveurs MCP',
          usage: 'le registre de consommation',
          gateway: 'la consommation de la passerelle',
        },
        emergencyStop: 'L\'arrêt d\'urgence de Veridion Core est actif.',
        coreMisconfigured: 'Il manque des réglages à Veridion Core : {missing}.',
        agentsWaiting: '{count} agents attendent une réponse.',
        hostedNotRunning: '{agent} ne tourne pas.',
        webhookMissing: 'Le webhook de {bot} n\'est pas enregistré.',
        readerNotAuthorised: 'La lecture des espaces de l\'entreprise n\'est pas autorisée.',
        approvalOpen: 'Approbation ouverte ({position}) : {question}',
        taskWaiting: 'Tâche de code en attente d\'une personne : {title}',
        taskReview: 'Merge request prête pour la revue : {title}',
      },
    },
    ops: {
      showDetails: 'Détails',
      hideDetails: 'Fermer',
      mcpVersion: 'Version',
      mcpUrl: 'Adresse',
      mcpProtocol: 'Transport et protocole',
      mcpLastRefresh: 'Dernière interrogation',
      mcpError: 'Erreur',
      noTools: 'Aucun outil signalé.',
      toolServer: 'Origine',
      toolAccess: 'Accès',
      toolBuiltIn: 'Veridion',
      accessReadOnly: 'lecture',
      accessWrites: 'écriture',
      accessDestructive: 'modifie des données',
      accessUndeclared: 'non déclaré',
      usageTitle: 'Consommation',
      smtmUsageSubtitle: 'Appels de modèles, tokens et coûts déclarés par le fournisseur sur les 30 derniers jours.',
      usageByPerson: 'Par personne',
      usageByModel: 'Par modèle',
      usageByDay: 'Par jour',
      model: 'Modèle',
      day: 'Jour',
      promptTokens: 'Tokens d\'entrée',
      completionTokens: 'Tokens de sortie',
      noUsage: 'Aucune consommation enregistrée.',
      runtimeTitle: 'Exécution',
      runtimeSubtitle: 'Comment l\'orchestrateur de cette instance s\'adresse à ses modèles et raccorde ses outils.',
      executionMode: 'Exécution',
      providerProtocol: 'Protocole vers le modèle',
      contextWindow: 'Fenêtre de contexte',
      requestTimeout: 'Délai par requête',
      diagnostics: 'Diagnostic',
      diagnosticsOn: 'activé',
      diagnosticsOff: 'désactivé (mode performance)',
      externalServers: 'Serveurs MCP connectés',
      mcpEndpoint: 'Point d\'accès MCP',
      workloadsTitle: 'Workloads',
      workloadsSubtitle: 'Les workloads de l\'espace de noms paioneer-veridion tels que Kubernetes les signale.',
      botsTitle: 'Bots',
      botsSubtitle: 'Les bots de l\'organisation, chacun avec son webhook, et les services du pont.',
      botAddress: 'Adresse',
      cardWebhook: 'Webhook des cartes',
      webhookState: 'État',
      noBots: 'Le pont ne signale aucun bot.',
      bridgeServices: {
        knowledgeBase: 'Base de connaissances',
        webResearch: 'Recherche sur Internet',
        osint: 'OSINT',
        anonymizer: 'Anonymisation',
      },
      connected: 'raccordé',
      notConnected: 'non raccordé',
      activeRooms: 'Salles actives',
      allowedRooms: 'Salles autorisées',
      surface: 'Surface',
      missingSettings: 'Réglages manquants',
      none: 'aucun',
      instanceToolsTitle: 'Outils de l\'orchestrateur',
      instanceToolsSubtitle: 'Les outils que l\'orchestrateur de l\'instance d\'entreprise a enregistrés.',
      openMailbox: 'Boîte',
      positionMailboxHint: 'Les collègues IA traitent les transmissions d\'autres collègues IA ; une mission pour un collègue IA se donne dans son espace Webex.',
      mailboxesTitle: 'Boîtes aux lettres',
      mailboxesSubtitle: 'Pour chaque agent, ce qui attend dans sa boîte, a été livré et a été lu. Un clic sur une ligne filtre les messages.',
      readAt: 'Lu à',
      refresh: 'Actualiser',
      mailbox: 'Boîte',
      mailboxKind: 'Type',
      mailboxKinds: {
        position: 'Collègue IA',
        hosted: 'Agent hébergé',
        graph: 'Agent',
      },
      lastMessage: 'Dernier message',
      noMailboxes: 'Aucune boîte lisible.',
      messagesTitle: 'Messages',
      messagesSubtitle: 'Messages, commandes et transmissions, les plus récents d\'abord. Un clic affiche le texte complet.',
      allMailboxes: 'Toutes les boîtes',
      allStates: 'Tous les états',
      time: 'Heure',
      from: 'De',
      to: 'À',
      messageKind: 'Type',
      content: 'Contenu',
      reply: 'Réponse',
      noMessages: 'Aucun message.',
      messageKinds: {
        message: 'Message',
        handover: 'Transmission',
        command: 'Commande',
        resume: 'Reprise',
        subagent_result: 'Résultat d\'un sous-agent',
        review: 'Revue',
      },
      buildsTitle: 'Builds',
      buildsSubtitle: 'Les images que Veridion Core a construites pour des agents, les plus récentes d\'abord.',
      image: 'Image',
      started: 'Démarré',
      finished: 'Terminé',
      noBuilds: 'Aucun build.',
      coreToolsTitle: 'Outils des agents',
      coreToolsSubtitle: 'Les outils de l\'orchestrateur que Veridion Core propose à ses agents.',
      description: 'Description',
      coreDailyTitle: 'Consommation par jour et par modèle',
      coreDailySubtitle: 'Appels de modèles de Veridion Core sur les 30 derniers jours, par agent et par modèle.',
      coreActivityTitle: 'Activité de Veridion Core',
      coreActivitySubtitle: 'Événements des agents, des collègues IA et des transmissions dans Veridion Core, les plus récents d\'abord.',
      event: 'Événement',
      tool: 'Outil',
      detail: 'Détail',
    },
    tabCompanyMemory: 'Mémoire de l\'entreprise',
    llmPaper: {
      subtitle: 'La description scientifique générée de l’architecture souveraine du modèle — rendue à partir du document de type article que Veridion Core tient pour la spécification active.',
      summaryTitle: 'Ce que montre cette page',
      summaryBody: 'Veridion Core tient pour l’architecture active un document scientifique généré : titre, résumé, sections numérotées, diagramme d’architecture, tableaux et références proviennent du backend sans modification ; les valeurs de conception sont signalées comme telles et la page n’invente rien.',
      refresh: 'Actualiser',
      exportPdf: 'Exporter en PDF',
      strandTraining: 'en entraînement',
      strandSelected: 'sélectionné',
      lcTitle: "Implémentation et cycle de vie",
      lcSelectedTrains: "entraîné ensuite",
      lcCollectsOnly: "collecte et prépare — ne démarre pas",
      lcSpec: "Spécification",
      lcFrozen: "gelée",
      lcArtifacts: "Artefacts (tokeniseur/codec)",
      lcReleased: "publiés",
      lcNotReleased: "pas encore construits",
      lcCodecOpen: "codec en attente",
      lcData: "Seuils de données",
      lcThresholdsMet: "atteints",
      lcAreasReached: "plan de données : {met} domaines sur {total} atteints",
      lcNoLake: "lac de données indisponible",
      lcStage_trainer_image: "Image d'entraînement",
      lcStage_sealed_tdv: "TDV scellée",
      lcStage_compat_all_green: "Compatibilité ALL-GREEN",
      lcStage_vram_budget: "Budget VRAM",
      lcTraining: "Entraînement",
      lcAuto: "démarre automatiquement une fois les seuils atteints",
      lcBench: "Benchmark",
      lcBenchRows: "mesures",
      lcNoneYet: "aucune encore",
      lcRelease: "Export · Hugging Face (privé) · registre",
      lcReleaseRows: "artefacts",
      lcReleaseNote: "après l'entraînement : upload vérifié privé + entrée au registre",
      lcPipeline: "Pipeline d'entraînement",
      lcDone: "fait",
      lcActive: "actif",
      lcWaiting: "en attente",
      lcBlocked: "bloqué",
      lcCapability: "Capacité",
      lcSamples: "Échantillons",
      lcByLanguage: "par langue",
      lcForeign: 'autre volet',
      lcCorpus: 'Jetons du corpus',
      lcCorpusNone: 'pas encore tokenisé',
      loading: 'Chargement …',
      unavailable: 'Le document n’est pas accessible.',
      noPaper: 'Cette version de Veridion Core ne fournit pas encore de document de type article. La page n’affiche donc rien d’inventé.',
      abstract: 'Résumé',
      references: 'Références',
      appendix: 'Annexe',
      figure: 'Figure',
      lastUpdated: 'Dernière mise à jour',
      empty: 'Aucune entrée.',
    },
    llmMonitor: {
      summary: "Supervision du modèle : état, données, GPU, kernels et débit, évaluations et événements — mesurés depuis Veridion Core et le data lake, rien d'inventé.",
      archTitle: 'Statut de l’architecture',
      archSubtitle: "L'architecture active avec l'état de l'interface de données et l'état de gel.",
      version: 'Version',
      codename: 'Nom de code',
      statusLabel: 'Statut',
      interfaceStatus: 'Interface de données',
      specSha: 'Hash de spécification (SHA-256, abrégé)',
      promotedAt: 'Promue',
      frozenLabel: 'Gelée',
      frozenYes: 'Oui',
      frozenNo: 'Non',
      stateWord_active: "active",
      stateWord_draft: "brouillon",
      stateWord_released: "publiée",
      stateWord_candidate: "candidate",
      stateWord_retired: "retirée",
      gpuModel: "Carte graphique",
      gpuTotal: "Mémoire graphique totale",
      gpuWindow: "Fenêtre d'entraînement (mesurée)",
      gpuMeasuredAt: "Mesuré le",
      gpuSource: "Source de la mesure",
      gpuServing: "Service",
      gpuInferenceTarget: "Objectif d'inférence sur une carte",
      vramTitle: 'GPU & budget VRAM',
      vramSubtitle: 'Le budget VRAM mesuré de la carte graphique tel que Veridion Core le tient.',
      vramNone: 'Aucun budget VRAM dans l’enregistrement.',
      gateTitle: 'Gate de promotion',
      gateSubtitle: 'La règle selon laquelle une architecture candidate remplace l’architecture active, avec les métriques requises et leurs poids.',
      metric: 'Métrique',
      weight: 'Poids',
      gateNone: 'Aucune métrique requise enregistrée.',
      candidatesTitle: 'Candidates',
      candidatesNone: 'Aucune architecture candidate.',
      evidenceTitle: 'Évaluations',
      evidenceNone: 'Pas encore d’évaluations mesurées.',
      benchmark: 'Benchmark',
      suite: 'Suite',
      score: 'Score',
      evaluator: 'Évaluateur',
      date: 'Date',
      changelogTitle: 'Historique des modifications',
      changelogNone: 'Pas encore de versions d’architecture dans l’historique.',
      summaryLabel: 'Résumé',
      createdAt: 'Créée',
      supersededAt: 'Remplacée',
      eventsTitle: 'Événements',
      eventsNone: 'Aucun événement enregistré.',
      implTitle: 'État d\'implémentation du volet',
      implSubtitle: "Faits mesurés : artefacts de l'interface de données, sélection, corpus de tokens et index vectoriel ; le plan de données par domaine figure dans la situation.",
      implSelected: 'Volet d\'entraînement',
      implSelectedYes: 'sélectionné — s\'entraîne ensuite',
      implSelectedNo: 'prépare seulement (ne démarre jamais)',
      implTokenizer: 'Artefact du tokenizer',
      implCodec: 'Artefact du codec',
      implNotReleased: 'pas encore publié',
      implCapability: 'Capacité',
      implSamples: 'Exemples (mesuré/objectif)',
      implNoDatalake: 'La progression des exemples est momentanément illisible (interface du data lake injoignable).',
      implSwitchHint: 'La sélection du volet d\'entraînement se change sur la page d\'entraînement.',
      implSituationLink: "Où en sont les données et ce qui manque à l'entraînement : la situation sur la page d'entraînement",
      kernelTitle: 'Accélération des noyaux & débit',
      kernelSubtitle: 'Ce que la sonde des noyaux a mesuré sur la carte : chaque noyau face à sa référence, le backend d\'attention, le débit de la spécification choisie — et le plan de temps calculé à partir des jetons mesurés et du débit mesuré.',
      kernelNone: 'Aucune sonde des noyaux n\'a encore tourné sur cette carte ; rien n\'est présumé.',
      kernelName: 'Noyau',
      kernelVerified: 'Prouvé',
      kernelYes: 'oui',
      kernelNo: 'non',
      kernelSpeedup: 'Accélération',
      kernelMaxErr: 'Erreur max.',
      kernelError: 'Constat',
      kernelAttention: 'Backend d\'attention',
      kernelDocMask: 'Masquage des frontières de documents',
      kernelThroughput: 'Débit mesuré (jetons/s)',
      kernelMicroBatch: 'Micro-lot',
      kernelMeasuredAt: 'Mesuré le',
      kernelImage: 'Image du trainer (digest)',
      kernelRunPath: 'Chemin des noyaux de la dernière exécution',
      kernelRunNone: 'Aucune exécution d\'entraînement avec des faits sur les noyaux pour l\'instant.',
      kernelPlanTitle: 'Plan de temps (arithmétique sur des mesures)',
      kernelPlanTokens: 'Masse de jetons',
      kernelPlanTokensSource: 'Source de la masse de jetons',
      kernelPlanDays: 'Jours projetés pour un passage',
      kernelPlanNone: 'Pas encore mesuré — sans débit mesuré ni masse de jetons mesurée, aucun plan de temps n\'est inventé.',
      kernelSourceTdv: 'version de données d\'entraînement scellée',
      kernelSourceCorpus: 'corpus actuel (non scellé)',
      kernelSourcePlan: "budget du papier",
      implForeign: 'appartient à un autre volet',
      implIndex: 'Index vectoriel (liage du graphe)',
      implIndexNone: 'aucun index signalé',
      implIndexDown: 'configuré, ne répond pas',
      implIndexPoints: 'points',
      implIndexBackfillDone: 'remplissage terminé',
      implIndexBackfillOpen: 'remplissage en cours',
      implIndexLink: 'Index et déduplication dans le moniteur du lac',
      implCorpus: 'Corpus de tokens (texte brut)',
    },
    software: {
      arch: {
        execTitle: "Architecture de modèle souveraine",
        execSubtitle: "L'unique spécification d'architecture active de Veridion Core : chaque chiffre est soit étayé par un artefact de mesure référencé, soit marqué par le backend comme objectif de conception (non mesuré).",
        openDatalake: "Ouvrir Data Lake & entraînement du modèle IA",
        unavailableArch: "Les données d'architecture sont injoignables.",
        frozen: "Gelée — un entraînement est actif",
        notFrozen: "Autorisée (phase A)",
        version: "Version",
        codename: "Nom de code",
        statusLabel: "Statut",
        createdAt: "Créée",
        promotedAt: "Promue",
        specSha: "Empreinte de la spécification (SHA-256)",
        contextWindow: "Fenêtre de contexte (conception, tokens)",
        dataInterface: "Interface de données",
        diStatus: {
          draft: "brouillon",
          complete: "complète",
          missing: "absente",
        },
        paramsTitle: "Bilan des paramètres",
        trainingVramTitle: "VRAM d'entraînement (déclarée, Go)",
        inferenceTitle: "VRAM d'inférence (déclarée, Go)",
        declaredTotal: "Total déclaré",
        budgetTitle: "Budget VRAM GPU (mesuré)",
        budgetGpu: "GPU",
        budgetTotal: "VRAM totale (MiB)",
        budgetFreed: "Budget d'entraînement libre (Go)",
        budgetInferenceTarget: "Objectif d'inférence mono-GPU (Go)",
        diagramTitle: "Diagramme d'architecture généré",
        diagramSubtitle: "Généré de façon déterministe à partir de la spécification stockée ; aucun diagramme écrit à la main n'existe à côté des données.",
        noDiagram: "La réponse ne contient pas de diagramme.",
        stagesTitle: "Structure par étages de l'architecture",
        stagesSubtitle: "Directement depuis la spécification stockée ; les chiffres de paramètres sont des valeurs de conception.",
        stageCol: "Étage",
        layersCol: "Couches",
        mechanismCol: "Mécanisme",
        paramsCol: "Paramètres physiques (Mds) & sources primaires",
        paramsCross: "transversal — compté dans les étages",
        researchTitle: "Archive de recherche IA quantique & frontier",
        researchSubtitle: "Lignes en direct de l'archive de recherche de Veridion Core ; les nouvelles publications arrivent par l'outil du collègue quantique, chacune avec son origine visible.",
        researchEmpty: "Aucune publication dans l'archive pour l'instant.",
        evidenceTitle: "Preuves d'évaluation",
        evidenceSubtitle: "Seules des évaluations mesurées et référencées apparaissent ici ; sans preuve, pas de score.",
        evalMetric: "Métrique",
        evalBenchmark: "Benchmark",
        evalSuite: "Suite",
        evalScore: "Valeur",
        evalEvaluator: "Évaluateur",
        evalDate: "Mesurée le",
        evalArtifact: "Artefact de preuve",
        gateTitle: "Règles de promotion (portail de preuves)",
        gateMetrics: "Métriques obligatoires",
        gateEpsilon: "Tolérance (epsilon)",
        gateConfigVersion: "Configuration du portail (version)",
        candidatesTitle: "File des candidats",
        candidatesSubtitle: "Candidats d'architecture soumis avec l'état de leurs preuves ; la soumission passe par l'environnement de recherche, jamais par le tableau de bord.",
        candidateSubmittedBy: "Soumis par",
        candidateEvidence: "Preuves (présentes / requises)",
        candidatesEmpty: "Aucun candidat soumis.",
        changelogTitle: "Journal des évolutions de conception",
        changelogSubtitle: "Itérations de conception remplacées — volontairement sans chiffres : rien n'a jamais été mesuré pour elles.",
        changelogSummary: "Résumé",
        changelogEmpty: "Aucune conception remplacée.",
        supersededAt: "Remplacée le",
        eventsTitle: "Événements du portail",
        eventsSubtitle: "Soumissions, promotions, rejets et transitions de gel tels que le portail les a consignés.",
        eventsEmpty: "Aucun événement pour l'instant.",
      },
      title: 'Développement logiciel',
      subtitle: 'Les tâches de l\'agent de programmation, le GitLab de l\'entreprise avec sa synchronisation depuis Azure DevOps, les merge requests en attente de revue et les limites du nœud GitLab.',
      openGitlab: 'Ouvrir GitLab',
      openSonar: 'Ouvrir SonarQube',
      loading: 'Chargement …',
      failed: 'Cela n\'a pas fonctionné',
      done: 'Fait',
      unavailable: 'Inaccessible',
      capacityTitle: 'Nœud GitLab',
      capacitySubtitle: 'Le gardien fixe chaque minute les limites du nœud selon la charge du serveur ; la production garde sa réserve.',
      stateLabel: 'État',
      memory: 'Mémoire',
      cpu: 'CPU',
      disk: 'Disque',
      hostFree: 'Libre sur le serveur',
      reserve: 'Réserve pour la production',
      codingSlots: 'Tâches simultanées',
      pipelineQuota: 'Jobs de pipeline',
      recentActions: 'Dernières interventions du gardien',
      syncTitle: 'Synchronisation depuis Azure DevOps',
      syncSubtitle: 'Le master de GitLab suit celui d\'Azure ; les commits que seul GitLab avait sont conservés sous une étiquette replaced/<heure>.',
      syncNow: 'Synchroniser maintenant',
      syncStarted: 'Synchronisation lancée',
      azureCommit: 'Master Azure',
      gitlabCommit: 'Master GitLab',
      lastChange: 'Dernier changement',
      lastRun: 'Dernière exécution',
      replaced: 'Conservé sous étiquettes',
      noneReplaced: 'rien',
      jobs: 'Dernières exécutions',
      error: 'Erreur',
      readyTitle: 'Merge requests prêtes pour la revue',
      readySubtitle: 'Uniquement les merge requests au pipeline vert ; la fusion se fait dans GitLab.',
      noReady: 'Aucune merge request en attente de revue.',
      tasksTitle: 'Tâches de programmation',
      tasksSubtitle: 'Chaque travail de programmation de l\'agent avec son état, sa merge request et ses tokens.',
      showFinished: 'Afficher les tâches terminées',
      task: 'Tâche',
      requester: 'Demandeur',
      statusLabel: 'État',
      mergeRequest: 'Merge request',
      pipeline: 'Pipeline',
      tokens: 'Tokens',
      updated: 'Mis à jour',
      noTasks: 'Aucune tâche de programmation pour le moment.',
      phase: 'Étape',
      repository: 'Dépôt',
      branch: 'Branche',
      openQuestion: 'Question ouverte',
      result: 'Résultat',
      sendMessage: 'Écrire à la tâche',
      answerQuestion: 'Répondre à la question',
      urgent: 'Urgent : orienter tout de suite l\'étape en cours',
      send: 'Envoyer',
      messageSent: 'Remis à la tâche',
      confirmCancel: 'Annuler cette tâche ? Une merge request ouverte sera fermée.',
      course: 'Déroulement de la session',
      messages: 'Messages',
      events: 'Événements',
      none: 'aucun',
      close: 'Fermer',
      newTitle: 'Nouvelle tâche',
      newSubtitle: 'Donnez ici une tâche à l\'agent de programmation ; suivez-la ici et sur sa carte Webex.',
      brief: 'Que doit faire l\'agent ?',
      issue: 'Ticket YouTrack (facultatif)',
      create: 'Créer la tâche',
      created: 'Tâche créée',
      usersTitle: 'Administrateurs dans GitLab',
      usersSubtitle: 'Chaque administrateur a un utilisateur GitLab avec les droits d\'administration ; le housekeeping les aligne sur Keycloak.',
      email: 'E-mail',
      gitlabUser: 'Utilisateur GitLab',
      lastHousekeeping: 'Dernier housekeeping',
      sonarDeleted: 'Projets SonarQube des branches supprimées retirés',
      previewsTitle: 'Projets en développement',
      previewsSubtitle: 'Chaque projet en développement tourne exactement une fois dès son premier merge : Veridion Core démarre le dernier état vert de la branche principale (migration ou master) dans des conteneurs derrière la connexion administrateur, le renouvelle à chaque pipeline verte, et les conteneurs se démarrent, s’arrêtent et se redémarrent ici. Un projet dont la pipeline ne construit rien qui tourne figure ici avec la raison.',
      previewsSummaryTitle: 'Ce que montre cette vue',
      previewsSummaryBody: 'Chaque projet en développement tourne dans son propre conteneur d’aperçu derrière la connexion administrateur. La liste en haut montre le dernier état exécutable de chaque projet, le tableau en dessous les conteneurs en cours avec état, adresse et commandes : ouvrir, démarrer, arrêter, redémarrer.',
      previewProject: 'Projet',
      previewState: 'État en cours',
      previewSince: 'Depuis',
      previewAddress: 'Adresse',
      previewMergedAt: 'Fusionné',
      noPreviews: 'Aucun projet ne tourne.',
      reasonsLabel: 'Causes de blocage & Diagnostic',
      noProjects: 'Aucun projet en développement.',
      qualityCoverage: 'Couverture',
      qualityBugs: 'Bugs',
      qualitySmells: 'Code smells',
      qualityDuplication: 'Duplication',
      qualityHotspots: 'Hotspots ouverts',
      qualityUnavailable: 'Aucune mesure SonarQube',
      openPreview: 'Ouvrir',
      startPreview: 'Démarrer les conteneurs',
      stopPreview: 'Arrêter les conteneurs',
      previewStarted: 'Conteneurs démarrés',
      previewStopped: 'Conteneurs arrêtés',
      restartPreview: 'Redémarrer les conteneurs',
      previewRestarted: 'Conteneurs redémarrés',
      previewControl: 'Conteneurs',
      resultTitle: 'Résultat dans GitLab',
      resultJobs: 'Jobs et artefacts',
      resultSonar: 'SonarQube',
      resultDelivered: 'Livré',
      previewStatus: {
        starting: 'démarre',
        running: 'en cours',
        stopped: 'arrêté',
        failed: 'en échec',
      },
      capacityStates: {
        ok: 'dans les limites',
        tight: 'juste : la production a besoin de la place',
        full: 'plein : pas de nouveau travail',
        node_down: 'le nœud ne tourne pas',
      },
      status: {
        queued: 'attend une place libre',
        working: 'en cours',
        waiting: 'attend une réponse',
        review: 'en revue',
        merged: 'fusionnée dans GitLab',
        done: 'terminée',
        needs_person: 'a besoin d\'une personne',
        rejected: 'fermée sans fusion',
        paused: 'en pause',
        cancelled: 'annulée',
        failed: 'échouée',
      },
      commands: {
        pause: 'Mettre en pause',
        resume: 'Reprendre',
        cancel: 'Annuler',
      },
      repositoryChoice: {
        auto: 'L\'agent décide',
        company: '{project} (fusion par une personne)',
        own: 'Un projet à lui dans {group}',
      },
      userState: {
        ok: 'aligné',
        created: 'créé',
        unblocked: 'débloqué',
        'made administrator': 'nommé administrateur',
        blocked: 'bloqué',
      },
    },
    org: {
      write: 'Écrire',
      call: "Appeler",
      callTitle: "Appel avec {bot}",
      writeTitle: 'Message à {bot}',
      callConfirmEnd: 'Terminer l\'appel ?',
      callSubtitle: 'Le microphone reste actif pendant tout l\'appel. Le bot salue de sa voix, répond brièvement, pose une question sur les points ouverts et peut être interrompu. Chaque phrase figure aussi dans Webex, dans la salle directe avec le bot.',
      callRinging: "Ça sonne …",
      callConnected: "Connecté",
      callEnded: "Terminé",
      callEndedHangup: "Vous avez raccroché",
      callEndedClosed: "La connexion a été coupée",
      callEndedSilence: "90 secondes de silence",
      callEndedLimit: "La limite de 30 minutes est atteinte",
      callEndedError: "Une erreur a mis fin à l’appel",
      callHangUp: "Raccrocher",
      callLevel: "Niveau du microphone",
      callYou: "Vous",
      callSpeaking: "Le bot parle …",
      callThinking: 'La réponse est en cours de génération …',
      callOvertaken: "dépassée par votre question suivante, non prononcée",
      callNothingHeard: "Aucun mot n’a été entendu.",
      callMicDenied: "Le navigateur a refusé le microphone ; autorisez-le pour cette page et rappelez.",
      callNoVoice: "La voix n’est pas disponible pour le moment ; la réponse reste en texte.",
      callRefused: "L’appel n’a pas été accepté : le ticket était invalide ou expiré ; rappelez.",
      callFailed: "L’appel a échoué",
      voice: "Voix",
      voiceHint: "La voix avec laquelle ce collègue parle : dans Webex, quand une personne demande à entendre la réponse, et au téléphone. Par défaut, c'est un locuteur du modèle audio chez OpenRouter ; une voix propre, clonée, du magasin de voix parle via le moteur vocal de la plateforme.",
      voiceSave: "Enregistrer la voix",
      voiceDefault: "par défaut",
      voiceNone: "aucune voix",
      voiceCloud: "Locuteurs OpenRouter (par défaut)",
      voiceOwn: "Voix propres (clonées)",
      voiceUploadTitle: "Téléverser un échantillon de voix pour ce collègue",
      voiceUploadHint: "Audio ou vidéo, 25 Mo au plus ; le Core convertit l’échantillon, en garde jusqu’à 20 secondes, en entend les mots et ne stocke que le clip de référence. Le collègue parle aussitôt avec cette voix.",
      voiceUploadName: "Nom de la voix",
      voiceUploadConsent: "Je confirme avoir le droit d’utiliser cette voix pour l’entreprise : c’est la mienne, ou la personne a donné son accord.",
      voiceUploadButton: "Téléverser l’échantillon",
      voiceUploadDone: "Voix enregistrée",
      voiceTooLarge: "Le fichier dépasse 25 Mo.",
      voicesTitle: "Voix",
      voicesSubtitle: "Chaque voix de l’entreprise est un clip de référence dans le magasin de voix de Veridion Core ; le moteur vocal la clone à chaque prise de parole d’un bot. Les neuf anciens locuteurs y figurent comme clips capturés.",
      voiceSeconds: "Secondes",
      voiceSource: "Origine",
      voiceSourcePreset: "locuteur capturé",
      voiceSourceUpload: "échantillon téléversé",
      voiceAddedBy: "Ajoutée par",
      voiceConsentBy: "Consentement confirmé par",
      voiceWords: "Mots du clip",
      voiceDelete: "Supprimer",
      voiceConfirmDelete: "Supprimer cette voix ? Les collègues qui l’utilisent reparleront avec leur voix par défaut.",
      voiceCapture: "Capturer les locuteurs du moteur à préréglages",
      voiceCaptureHint: "Prononce une phrase fixe par locuteur via le moteur à préréglages et l’enregistre comme clip ; s’exécute avant le changement de moteur.",
      voiceCaptured: "Capturées",
      voiceEnginePresets: "Le moteur vocal propose des locuteurs fixes ; le magasin de voix n’est pas utilisé.",
      chartTitle: "Organigramme",
      executiveTitle: 'Niveau de direction',
      unitsTitle: 'Unités d\'affaires',
      unitLead: 'Responsable',
      unitSupporting: 'Soutenu par',
      unitMission: 'Mission',
      unitPrefix: 'Préfixe du fil',
      standingActive: 'actif',
      standingStandby: 'en veille',
      standbyOn: 'Mettre en veille',
      standbyOff: 'Activer',
      standbyHint: 'En veille, un collègue ne prend aucun tour à l\'initiative de l\'entreprise et ne coûte aucun token ; un message direct d\'une personne reçoit toujours une réponse.',
      confirmStandby: 'Mettre {name} en veille ?',
      confirmActivate: 'Activer {name} ?',
      activity: 'Activité',
      runtime: 'Environnement d\'exécution',
      modelCloud: 'modèle cloud',
      modelGpu: 'moteur de l\'entreprise',
      callModel: 'Modèle téléphonique',
      calls30: 'Appels, 30 derniers jours',
      telemetryLine: '{model} · {prompt}+{completion} tokens · {cost} · oreille {asr} ms · esprit {llm} ms · voix {tts} ms · total {total} ms{deferred}',
      telemetryDeferred: ' · {count} différés',
      chartSubtitle: "Les collègues IA de Veridion : des agents dans Veridion Core, chacun joignable comme son propre bot Webex, par domaine ; au-dessus les décideurs humains, en dessous les agents sans bot propre et les espaces de l'entreprise, lus en direct dans Veridion Core et Webex.",
      chartPeople: "Décideurs humains",
      chartPeopleText: "Les décideurs humains décident de tout et agissent dans {space}.",
      chartAgentsTitle: "Agents sans bot propre : l'agent de codage, l'orchestrateur MCP de Veridion et les agents construits par l'architecte travaillent pour le compte d'un collègue IA et parlent par son bot",
      chartDesigned: "Agents conçus avec l'architecte",
      chartFor: "Pour le compte de",
      chartSystemsTitle: "Systèmes connectés",
      chartSpaceHome: "Espace d'attache de",
      chartSpacePurpose: "Objet",
      chartRoomsTitle: "Espaces de l'entreprise dans Webex",
      room: "Espace",
      roomBots: "Bots",
      positionsTitle: "Collègues IA",
      positionsSubtitle: "Chaque collègue IA répond par son propre bot et lit ses espaces. Sa description est l'instruction selon laquelle il travaille.",
      bot: "Bot",
      position: "Fonction",
      statusLabel: "Statut",
      tokensUsed: "Tokens utilisés",
      tokens30: "Tokens, 30 derniers jours",
      edit: "Modifier",
      close: "Fermer",
      description: "Description du collègue IA",
      save: "Enregistrer",
      resetDescription: "Rétablir la description par défaut",
      interests: "Profil d'intérêts",
      interestsHint: "Quels types de points et quels sujets concernent ce collègue IA, et quand il n'est pas concerné. Le collègue IA évalue chaque message de ses espaces à cette aune.",
      threshold: 'Seuil des interventions non sollicitées',
      thresholdHint: 'De 1 à 5 : à quel point un message doit concerner le collègue IA avant qu\'il intervienne sans y être invité. À 1, il intervient dès une faible pertinence, à 5 seulement à une pertinence élevée.',
      saveProfile: "Enregistrer le profil",
      tools: "Outils",
      decisionMakersTitle: "Décideurs",
      decisionMakersSubtitle: "Chacun d'eux peut donner toute approbation et répondre à toute question d'un collègue IA dans Webex.",
      email: "Adresse e-mail",
      add: "Ajouter",
      remove: "Retirer",
      confirmRemove: "Retirer ce décideur ?",
      readerTitle: "Lecture des espaces de l'entreprise",
      readerSubtitle: "Un bot ne voit que les messages qui le mentionnent. Veridion lit chaque message des espaces de l'entreprise grâce à l'autorisation d'un compte membre de tous ces espaces.",
      notConfigured: "L'intégration n'est pas configurée",
      authorised: "Autorisé",
      notAuthorised: "Non autorisé",
      account: "Compte",
      validUntil: "Jeton d'accès valable jusqu'au",
      renewUntil: "Autorisation renouvelable jusqu'au",
      authorise: "Autoriser la lecture",
      authoriseAgain: "Autoriser à nouveau",
      linkOpened: "La connexion Webex s'est ouverte dans un nouvel onglet.",
      found: "trouvé",
      notFound: "introuvable",
      botsInSpace: "bots",
      transcripts: "Transcriptions de réunions",
      yes: "oui",
      no: "non",
      approvalsTitle: "Approbations en attente",
      approvalsSubtitle: "Approbations et questions demandées par les collègues IA auxquelles aucun décideur n'a encore répondu.",
      originSpace: "Espace",
      directRoom: "conversation directe",
      approvalKinds: { review: "approbation", question: "question" },
      schedulesTitle: "Planifications",
      schedulesSubtitle: "Travail récurrent demandé dans un espace ; il s'exécute jusqu'à ce que quelqu'un l'arrête.",
      createdBy: "demandé par",
      lastRun: "dernière exécution",
      end: "Arrêter",
      confirmEnd: "Arrêter cette planification ?",
      none: "Aucun",
      loading: "Chargement…",
      failed: "Échec",
      working: "En cours…",
      done: "Terminé",
      memoryTitle: "Organisation",
      memorySubtitle: "Les personnes et les collègues IA de l'entreprise avec l'espace de mémoire dans lequel chaque collègue IA travaille.",
      memoryMember: "Membre",
      area: "Pôle",
      decisionMaker: "Décideur",
      status: { running: "actif" },
    },
    core: {
      conversationTitle: 'Conversation depuis le tableau de bord',
      conversationHint: 'Chaque message et chaque réponse sont aussi dits dans Webex : dans le fil du travail de l\'agent, sinon dans votre espace direct avec le bot.',
      conversationEmpty: 'Pas encore de message depuis le tableau de bord.',
      writeToAgent: 'Message à cet agent',
      answerPending: 'Réponse en attente',
      title: 'Veridion Core',
      subtitle: 'Le système d\'exploitation agentique derrière le bot de l\'entreprise : ses agents, leurs messages et leur consommation de tokens, les définitions, l\'architecte et l\'organisation.',
      done: 'Terminé.',
      failed: 'Cela n\'a pas fonctionné',
      loading: 'Chargement …',
      working: 'Traitement …',
      none: 'Aucun.',
      unavailable: 'Veridion Core est injoignable',
      errors: {
        AGENT_FINISHED: 'L\'agent est terminé et n\'accepte plus de messages',
        EMERGENCY_STOP: 'L\'arrêt d\'urgence est actif',
        DEFINITION_INVALID: 'La définition n\'est pas valide',
        TOO_MANY_AGENTS: 'Trop d\'agents sont en cours d\'exécution',
        VERIDION_CORE_NOT_CONFIGURED: 'Veridion Core n\'est pas configuré',
        MESSAGE_EMPTY: 'Le message est vide',
      },
      status: {
        building: 'construction de l\'image',
        starting: 'démarrage',
        running: 'en cours',
        waiting: 'en attente',
        idle: 'prêt',
        paused: 'en pause',
        completed: 'terminé',
        failed: 'échoué',
        cancelled: 'annulé',
        stopped: 'arrêté',
        not_deployed: 'non déployé',
      },
      statusLabel: 'Statut',
      owner: 'Propriétaire',
      definition: 'Définition',
      parent: 'Agent parent',
      tokens: 'Tokens',
      progress: 'Progression',
      close: 'Fermer',
      openQuestion: 'Question ouverte',
      result: 'Résultat',
      answerQuestion: 'Répondre à la question',
      sendMessage: 'Message à l\'agent',
      urgent: 'Urgent : interrompre l\'étape en cours',
      send: 'Envoyer',
      messageSent: 'Transmis à l\'agent.',
      commands: {
        pause: 'Mettre en pause',
        resume: 'Reprendre',
        cancel: 'Annuler',
        kill: 'Arrêter immédiatement',
      },
      confirmKill: 'Arrêter immédiatement cet agent et ses sous-agents ?',
      subAgents: 'Sous-agents',
      graph: 'Graphe',
      messages: 'Messages',
      messageStatus: {
        queued: 'en file d\'attente',
        delivered: 'remis',
        consumed: 'lu',
        refused: 'refusé',
      },
      events: 'Événements',
      containerLog: 'Journal du conteneur',
      version: 'Version',
      activeAgents: 'Agents actifs',
      updated: 'Mis à jour',
      archived: 'archivé',
      noDefinitions: 'Aucune définition pour l\'instant.',
      versions: 'Versions',
      from: 'de',
      startInput: 'Entrée de démarrage en JSON',
      agentStarted: 'Agent démarré.',
      startAgent: 'Démarrer l\'agent',
      editAsJson: 'Modifier en JSON',
      confirmArchive: 'Archiver cette définition ? Les agents en cours continuent de s\'exécuter.',
      archive: 'Archiver',
      definitionJson: 'Définition en JSON',
      definitionJsonHint: 'Une définition dans le langage de graphes Veridion. Valider affiche ses problèmes et son graphe ; enregistrer la stocke comme nouvelle version approuvée.',
      checked: 'Vérifié.',
      validate: 'Valider',
      saved: 'Enregistré comme nouvelle version.',
      saveVersion: 'Enregistrer comme nouvelle version',
      valid: 'La définition est valide.',
      you: 'Vous',
      architect: 'Architecte',
      architectPlaceholder: 'Décrivez ce que l\'agent doit faire …',
      newDesign: 'Nouvelle conception',
      unitKinds: {
        company: 'entreprise',
        department: 'service',
        team: 'équipe',
        project: 'projet',
      },
      partOf: 'fait partie de',
      confirmRemove: 'Supprimer cette unité ? Ses membres perdent ce périmètre.',
      remove: 'supprimer',
      addUnit: 'Ajouter une unité',
      unitId: 'Identifiant (minuscules, tirets)',
      unitName: 'Nom',
      add: 'Ajouter',
      addMember: 'Ajouter un membre',
      memberKinds: {
        person: 'personne (adresse e-mail)',
        agent: 'agent (identifiant)',
        definition: 'définition (identifiant)',
      },
      memberId: 'Adresse e-mail ou identifiant',
      role: 'Rôle',
      confirmEmergencyOn: 'Arrêter tous les agents maintenant ? Le bot continue de répondre.',
      confirmEmergencyOff: 'Lever l\'arrêt d\'urgence ?',
      emergencyStop: 'Arrêt d\'urgence',
      emergencyRelease: 'Lever l\'arrêt d\'urgence',
      emergencyActive: 'l\'arrêt d\'urgence est actif',
      autopilotOn: 'Activer le pilote automatique',
      autopilotOff: 'Désactiver le pilote automatique',
      autopilotActive: 'Pilote automatique actif : Veridion Core répond lui-même à chaque carte destinée aux personnes',
      autopilotUnitsTitle: 'Pilote automatique par unité opérationnelle',
      autopilotUnitsHint: 'Active ou désactive le pilote automatique individuellement pour chaque unité opérationnelle et la couche exécutive. Le travail suspendu reste intouché.',
      autopilotUnitOn: 'Pilote actif',
      autopilotUnitOff: 'Pilote inactif',
      limitsBuilds: 'Builds d’image par collègue et par jour',
      limitsDesigns: 'Conceptions d’agents par collègue et par jour',
      limitsSave: 'Définir les limites quotidiennes',
      limitsNone: '0 = pas de limite',
      confirmAutopilotOn: 'Activer le pilote automatique ? Le décideur propre de Veridion Core répond alors aussitôt à chaque carte ouverte et à chaque nouvelle carte dans pAIoneer-humans-and-bots, visiblement dans le fil de la carte.',
      confirmAutopilotOff: 'Désactiver le pilote automatique ? Dès lors, les personnes décident à nouveau.',
      model: 'Modèle',
      codingModel: 'Modèle de programmation',
      modelsTitle: 'Modèles par rôle',
      modelsSubtitle: 'Sur quel modèle pense chaque rôle de Veridion Core : le visage et le pilotage de l\'entreprise, le téléphone, l\'architecte et le juge des verdicts d\'ingénierie des exigences. Seuls les modèles routés par la passerelle peuvent être choisis ; vide signifie la valeur par défaut de la configuration.',
      roleCoordinator: 'Coordinateur (visage et pilotage)',
      roleCall: 'Téléphone',
      roleArchitect: 'Architecte',
      roleRequirementsJudge: 'Juge des exigences',
      roleJudge: 'Jugements du Core',
      roleEar: 'Oreille du téléphone',
      roleStt: 'Oreille Webex',
      modelGroupVllm: 'vLLM (carte propre)',
      modelGroupAudio: 'Audio (carte propre / cloud)',
      modelGroupCloud: 'OpenRouter (cloud)',
      directLlmTitle: 'Accès direct au LLM',
      directLlmSubtitle: 'Parlez directement à un vLLM ou à un modèle cloud, sans bots, agents ni Webex',
      directLlmHint: 'Accès administrateur direct : le modèle choisi répond brut, comptabilisé sous « console », sans lanes, rôles ni outils.',
      directLlmModel: 'Modèle',
      directLlmSystem: 'Invite système (facultatif)',
      directLlmSystemPlaceholder: 'p. ex. Tu es …',
      directLlmPrompt: 'Message',
      directLlmPromptPlaceholder: 'Que voulez-vous demander directement au modèle ?',
      directLlmSend: 'Envoyer',
      directLlmSending: 'Envoi …',
      directLlmUsage: '{prompt}+{completion} jetons · {cost}',
      modelCurrent: 'En service',
      modelDefault: 'Par défaut',
      modelChosen: 'Choisi',
      modelDefaultOption: 'la valeur par défaut de la configuration',
      modelNotRouted: 'non routé par la passerelle',
      modelSave: 'Enregistrer',
      engineSilver: 'Moteur de l\'entreprise (argent)',
      engineGold: 'Moteur de l\'entreprise (or, celui de l\'orchestrateur)',
      callsTitle: 'Appels téléphoniques',
      callsSubtitle: 'Chaque tour parlé du téléphone, comptabilisé à part du travail des collègues : tokens, coût et temps pris par l\'oreille, l\'esprit et la voix, par collègue et modèle, pour les 30 derniers jours et aujourd\'hui ; en dessous, les tours les plus récents.',
      callsTurns: 'Tours',
      callsCalls: 'Appels',
      callsAvgTotal: 'Ø total ms',
      callsAvgAsr: 'Ø oreille ms',
      callsAvgLlm: 'Ø esprit ms',
      callsAvgTts: 'Ø voix ms',
      callsDeferred: 'Différés',
      callsToday: 'Aujourd\'hui',
      callsWindow: '30 derniers jours',
      callsRecent: 'Tours les plus récents',
      callsPerson: 'Personne',
      callsRounds: 'Tours de table',
      callsNone: 'Aucun appel comptabilisé pour l\'instant.',
      unitKindExecutive: 'Niveau de direction',
      unitKindBusinessUnit: 'Unité d\'affaires',
      orgSynced: 'Le niveau de direction et les unités d\'affaires sont définis dans l\'organisation de Veridion Core et synchronisés ici ; ils se modifient là-bas, pas sur cette page.',
      memory: 'Mémoire',
      ready: 'prêt',
      notReady: 'pas prêt',
      factExtraction: 'extraction de faits active',
      cluster: 'Accès au cluster',
      agentsRunning: 'Agents actifs',
      agentsWaiting: 'en attente',
      definitions: 'Définitions',
      gatewayIdentity: 'Identité sur la passerelle',
      gatewayTokens: 'Tokens de la passerelle dans la fenêtre',
      hostedTitle: 'Agents hébergés',
      hostedSubtitle: 'Applications d\'IA que Veridion Core démarre et exploite dans leurs propres conteneurs.',
      agent: 'Agent',
      actions: 'Actions',
      confirmHosted: '{action} : {agent} ?',
      hostedActions: {
        start: 'démarrer',
        stop: 'arrêter',
        restart: 'redémarrer',
      },
      open: 'ouvrir',
      agentsTitle: 'Agents',
      agentsSubtitle: 'Chaque agent et sous-agent s\'exécute dans son propre conteneur. Ouvrez-en un pour lui écrire ou le piloter.',
      showFinished: 'Afficher les agents terminés',
      noAgents: 'Aucun agent.',
      definitionsTitle: 'Définitions',
      definitionsSubtitle: 'Graphes d\'agents approuvés avec leurs versions.',
      designsTitle: 'Conceptions d\'agents',
      designsSubtitle: 'Chaque agent conçu par l\'architecte, pour une personne ou pour le travail d\'un collègue IA : pour quoi et pourquoi, chaque question avec sa réponse, les tests contre les scénarios, l\'approbation et les exécutions.',
      design: 'Conception',
      designFor: 'Pour',
      designWork: 'Travail',
      designState: 'État',
      designApprovedBy: 'Approuvé par',
      designAgent: 'Agent construit',
      filterState: 'État',
      filterAll: 'Tous',
      filterOpen: 'Ouverts',
      filterDone: 'Terminés',
      filterFailed: 'Échoués',
      filterCurrent: 'Actifs et échoués récemment',
      filterActive: 'Actifs',
      filterFinished: 'Terminés',
      filterPosition: 'Collègue IA',
      pagePrev: 'Précédent',
      pageNext: 'Suivant',
      pageLabel: 'Page',
      searchLabel: 'Rechercher',
      showMore: 'Afficher plus',
      noDesigns: 'Aucun agent conçu pour l\'instant.',
      designReason: 'Pourquoi les outils ne suffisaient pas',
      designRecord: 'Historique',
      designAgents: 'Agents de la conception',
      designTestRun: 'Test',
      designRun: 'Exécution',
      designStatus: { designing: 'en conception', testing: 'en test', asking: 'attend une réponse', approval: 'attend l\'approbation', running: 'en cours', done: 'terminé', failed: 'échoué', cancelled: 'annulé' },
      builtBy: 'Construit par',
      builtFor: 'Pour le travail',
      viaCodingTask: 'via l\'agent de programmation',
      designTests: 'Tests',
      designRuns: 'Exécutions',
      designByPerson: 'une personne en conversation',
      diagramsTitle: 'Diagrammes',
      diagramsSubtitle: 'Images de flux, d\'architectures et de plans dessinées par les collègues IA, les agents et l\'agent de programmation, avec titre, légende et code Mermaid.',
      noDiagrams: 'Aucun diagramme pour l\'instant.',
      diagramAuthor: 'Auteur',
      diagramBasedOn: 'Étend',
      diagramCode: 'Code Mermaid',
      architectTitle: 'Architecte',
      architectSubtitle: 'Concevez un agent par la conversation. L\'architecte demande ce qu\'il ne peut pas trancher lui-même et ne crée l\'agent qu\'après votre approbation.',
      orgTitle: 'Organisation',
      orgSubtitle: 'Services, équipes et projets avec leurs membres ; la mémoire de l\'entreprise est partagée selon cette structure.',
      usageTitle: 'Consommation par agent',
      usageSubtitle: 'Appels de modèles, tokens et coûts déclarés des 30 derniers jours.',
      calls: 'Appels',
      source: 'Source',
      gpuTokens: 'Jetons sur la carte graphique',
      cloudTokens: 'Jetons dans le cloud',
      usageByModel: 'Par collègue et modèle',
      cost: 'Coût',
    },
    memory: {
      archOverviewTitle: "Vue d'architecture : comment la mémoire d'entreprise est construite",
      archOverviewText: "Veridion Core conserve le savoir de l'entreprise en trois couches : Neo4j comme graphe de connaissances temporel pour les faits, décisions et lots de travail, PostgreSQL pour les états transactionnels des agents, boîtes aux lettres et sprints, et Qdrant pour la recherche vectorielle sur les documents d'entreprise. Chaque business unit travaille dans un domaine de connaissances isolé ; les résultats inter-unités passent par des transmissions consignées.",
      clustersTitle: "Domaines de connaissances des business units",
      clustersSubtitle: "Chaque business unit travaille dans un domaine de connaissances Neo4j délimité ; les nombres de nœuds et d'arêtes viennent en direct de Neo4j, les descriptions du peuplement initial marqué. Un clic ouvre le domaine dans le graphe de connaissances.",
      clusterCode: "Code",
      clusterName: "Domaine de connaissances",
      clusterId: "Identifiant",
      clusterRoles: "Rôles",
      clusterBridges: "Ponts de transmission",
      clusterPolicy: "Périmètre métier & règle d'isolation",
      clusterCounts: "Nœuds / arêtes (en direct)",
      clusterInsights: "Constats (peuplement initial)",
      clusterOpenButton: "Ouvrir dans le graphe de connaissances",
      countsUnavailable: "Neo4j injoignable — pas de comptage",
      researchTitle: "Archive de recherche IA quantique & frontier",
      researchSubtitle: "Publications scientifiques fondamentales & références d'architecture — lignes en direct de Veridion Core ; l'origine de chaque ligne est visible.",
      researchEmpty: "Aucune publication dans l'archive pour l'instant.",
      researchIngestNote: "Les nouvelles publications sont ajoutées par le collègue quantique via son outil ; le tableau de bord ne fait que lire l'archive.",
      researchPublication: "Publication",
      researchMechanism: "Mécanisme clé",
      researchRelevance: "Pertinence pour l'architecture",
      researchOrigin: "Origine",
      researchSeeded: "peuplement initial",
      researchMotivates: "Motive la version",
      title: 'Mémoire de l\'entreprise',
      subtitle: 'Ce que Veridion Core conserve dans Neo4j : des souvenirs par périmètre, des faits avec leur période de validité et l\'audit des actions des agents.',
      failed: 'Cela n\'a pas fonctionné',
      loading: 'Chargement …',
      unavailable: 'La mémoire est injoignable',
      database: 'Base de données',
      ready: 'prête',
      notReady: 'pas prête',
      factExtraction: 'Extraction de faits',
      episodesQueued: 'Épisodes en attente',
      lastError: 'Dernière erreur',
      contentTitle: 'Contenu',
      contentSubtitle: 'Nœuds par label et souvenirs par périmètre et type.',
      label: 'Label',
      count: 'Nombre',
      empty: 'Rien pour l\'instant.',
      scope: 'Périmètre',
      kind: 'Type',
      kinds: {
        fact: 'fait',
        decision: 'décision',
        task: 'tâche',
        procedure: 'procédure',
        note: 'note',
        episode: 'épisode',
      },
      searchTitle: 'Recherche',
      searchSubtitle: 'La recherche utilisée par les agents : sens, mots et faits extraits.',
      searchPlaceholder: 'Terme de recherche ou question',
      allScopes: 'tous les périmètres',
      search: 'Rechercher',
      noResults: 'Aucun résultat.',
      text: 'Texte',
      validFrom: 'Valide depuis',
      source: 'Source',
      extracted: 'extrait',
      recorded: 'enregistré',
      rememberTitle: 'Mémoriser',
      rememberSubtitle: 'Enregistrer un fait, une décision, une tâche, une procédure ou une note dans un périmètre.',
      remembered: 'Enregistré.',
      remember: 'Mémoriser',
      created: 'Créé',
      validity: 'Validité',
      invalid: 'invalide',
      confirmInvalidate: 'Marquer ce souvenir comme n\'étant plus valide ?',
      invalidate: 'marquer comme invalide',
      forget: 'oublier',
      confirmForget: 'Oublier définitivement cette entrée ? Elle est supprimée de la mémoire et ne peut pas être restaurée.',
      forgotten: 'Oublié.',
      factsTitle: 'Faits dans le temps',
      factsSubtitle: 'Faits extraits des conversations et des résultats des agents ; un fait contredit reçoit une date de fin.',
      noFacts: 'Aucun fait extrait pour l\'instant.',
      briefsTitle: 'Synthèses des collègues IA',
      briefsSubtitle: 'Ce que chaque collègue IA lit en premier : engagements ouverts, décisions valables, affaires en cours et clients, rédigé chaque nuit à partir de la mémoire.',
      brief: 'Synthèse',
      updated: 'Mis à jour',
      noBriefs: 'Aucune synthèse rédigée pour l\'instant.',
      fact: 'Fait',
      from: 'De',
      to: 'À',
      validUntil: 'Valide jusqu\'au',
      stillValid: 'toujours valide',
      entityTitle: 'Voisinage',
      entitySubtitle: 'Ce à quoi une tâche, un projet, une personne, un système ou une entité est lié.',
      entityPlaceholder: 'Nom, identifiant de tâche, adresse e-mail ou identifiant',
      show: 'Afficher',
      auditTitle: 'Audit',
      auditSubtitle: 'Appels de modèles et d\'outils, messages et sous-agents lancés.',
      auditPlaceholder: 'Identifiant d\'agent (vide : tous)',
      filter: 'Filtrer',
      time: 'Heure',
      agent: 'Agent',
      event: 'Événement',
      toolOrModel: 'Outil ou modèle',
      status: 'Statut',
      detail: 'Détail',
      consoleTitle: 'Console de requêtes',
      consoleSubtitle: 'Cypher en lecture seule ; les instructions d\'écriture sont refusées.',
      run: 'Exécuter',
      truncated: 'lignes supplémentaires tronquées',
      graph: {
        clusterPickTitle: "Focaliser un domaine de connaissances dans le graphe",
        clusterPickHint: "Un clic sur une business unit focalise son sous-graphe avec rôles et ponts de transmission dans le graphe interactif.",
        allClusters: "Tous les domaines (graphe complet)",
        activeCluster: "Domaine de connaissances actif",
        publicationsTitle: "Publications de l'archive de recherche",
        storesTitle: 'Stockages de la mémoire de l\'entreprise',
        storesSubtitle: 'Ce que contient chaque stockage de la mémoire de l\'entreprise, lu en direct : le graphe dans Neo4j, l\'état de Veridion Core dans Postgres, les vecteurs de la base de connaissances dans Qdrant.',
        storeNeo4j: 'Neo4j (graphe)',
        storeNeo4jHolds: 'La mémoire de l\'entreprise : les souvenirs avec leur périmètre, les entités et les faits extraits par Graphiti avec leur période de validité, les éléments de travail avec leur sens, le travail logiciel et l\'audit des agents.',
        storePostgres: 'Postgres (relationnel)',
        storePostgresHolds: 'L\'état transactionnel de Veridion Core : la table des processus des agents, les boîtes aux lettres, les conversations, les points de reprise, les tâches de codage, les approbations, l\'organisation et la consommation.',
        storeQdrant: 'Qdrant (vecteurs)',
        storeQdrantHolds: 'La base de connaissances de l\'entreprise : les passages vectorisés des documents ajoutés par un administrateur, interrogés par l\'orchestrateur quand un tour de conversation a besoin de la base de connaissances.',
        nodes: 'nœuds',
        relationships: 'relations',
        relationshipType: 'Type de relation',
        tables: 'tables',
        table: 'Table',
        rows: 'lignes',
        purpose: 'Ce qu\'elle contient',
        documents: 'documents',
        session: 'Session',
        collection: 'Collection',
        role: 'Rôle',
        roleDocuments: 'documents',
        roleCurated: 'paires question-réponse validées',
        title: 'Graphe',
        subtitle: 'Le graphe de la mémoire de l\'entreprise dans Neo4j : partez d\'un résultat de recherche, des souvenirs les plus récents ou des éléments de travail ; cliquez sur un nœud pour le lire, développez ses voisins, glissez pour ordonner, faites défiler pour zoomer.',
        startNewest: 'Souvenirs récents',
        startWork: 'Éléments de travail',
        searchPlaceholder: 'Nom, texte ou identifiant à trouver dans le graphe',
        find: 'Chercher',
        noHits: 'Rien trouvé.',
        name: 'Nom',
        sources: { memory: 'souvenir', entity: 'entité extraite', node: 'mémoire de projet', episode: 'épisode' },
        show: 'afficher',
        shown: '{nodes} nœuds et {edges} relations dans le graphe',
        truncated: 'coupé à la limite ; développez un nœud ou cherchez plus précisément',
        selected: 'Nœud sélectionné',
        selectHint: 'Cliquez sur un nœud du graphe.',
        expand: 'Développer les voisins',
        expandTwo: 'Développer deux niveaux',
        centre: 'Centrer sur ce nœud',
        facts: 'Faits de cette entité',
        degree: 'Relations',
        direction: 'Direction',
        out: 'sortante',
        in: 'entrante',
        noRelationships: 'Aucune relation.',
        property: 'Propriété',
        value: 'Valeur',
        noProperties: 'Aucune propriété.',
        factsOf: 'Faits de',
        factsSubtitle: 'Ce que Graphiti a extrait sur cette entité, avec la période de validité de chaque fait ; un fait contredit porte une date de fin.',
        relation: 'Relation',
        other: 'Autre entité',
        newestTitle: 'Souvenirs récents',
        newestSubtitle: 'Les derniers souvenirs écrits, avec leur objet ; « afficher » en dessine un avec ses liens.',
        about: 'Objet',
        workTitle: 'Éléments de travail',
        workSubtitle: 'Chaque travail confirmé avec son état, son responsable, son ticket et les résultats de ses scénarios ; « afficher » en dessine un avec son sens, son ticket, ses tâches de codage et les agents construits pour lui.',
        allStates: 'tous les états',
        states: { confirmed: 'confirmé', in_progress: 'en cours', blocked: 'bloqué', done: 'terminé', failed: 'échoué', dropped: 'abandonné' },
        workItem: 'Élément de travail',
        owner: 'Responsable',
        issue: 'Ticket',
        scenarios: 'Scénarios',
        results: { passed: 'réussi', failed: 'échoué', pending: 'en attente' },
      },
      day: {
        title: 'La journée de l\'entreprise',
        subtitle: 'La chronologie des événements que Veridion Core consigne : les paroles des personnes, les cartes, le travail, les passations, les recherches, les agents, les tâches de codage, les projets, les incidents et les réunions, du plus récent au plus ancien.',
        sinceToday: 'aujourd\'hui',
        sinceDay: '24 dernières heures',
        sinceWeek: '7 derniers jours',
        allKinds: 'tous les types',
        refresh: 'Actualiser',
        count: '{n} événements',
        time: 'Heure',
        actor: 'Acteur',
        happening: 'Événement',
        work: 'Travail',
        empty: 'Rien de consigné dans cette période.',
        kinds: { word: 'parole', request: 'demande', card: 'carte', work: 'travail', handover: 'passation', research: 'recherche', agent: 'agent', task: 'tâche de codage', project: 'projet', incident: 'incident', schedule: 'planification', meeting: 'réunion', message: 'message' },
      },
    },
    title: 'Tableau de bord d\'administration',
    adminKicker: 'Exploitation',
    smtmStatusTitle: 'Données et prévisions SMTM',
    smtmStatusSubtitle: 'Surveille les séries temporelles du courtier, les modèles publiés, les sorties de prédiction et les flux RSS.',
    smtmStatusUnavailable: 'État SMTM indisponible',
    smtmGeneratedAt: 'Généré le',
    smtmMinimumRows: 'Lignes d\'entraînement minimales',
    smtmBaseFrames: 'Séries temporelles de base',
    smtmTrainableFrames: 'Données brutes prêtes',
    smtmWaitingHistory: 'En attente d\'historique',
    smtmPredictionTrackedInstruments: 'Instruments suivis',
    smtmPredictionEnabledCount: 'Prédictions activées',
    smtmPredictionDisabledCount: 'Prédictions en pause',
    smtmMlFrames: 'Jeux de données ML',
    smtmOnlineModels: 'Modèles en ligne',
    smtmModelsWithArtifacts: 'Modèles avec artefacts',
    smtmPredictionFrames: 'Séries de prédiction',
    smtmMissingPredictions: 'Séries sans prédiction',
    smtmBlobArtifacts: 'Artefacts blob',
    smtmStalePredictions: 'Prédictions obsolètes',
    smtmRssFrames: 'Flux RSS',
    smtmDataframesTotal: 'Total des jeux de données',
    smtmLatestModelUpload: 'Dernier envoi de modèle',
    smtmLatestPredictionWrite: 'Dernière écriture de prédiction',
    smtmRuntimeHints: 'Avertissements d\'exécution',
    smtmNoHints: 'Aucun avertissement SMTM en cours.',
    smtmInstrument: 'Instrument',
    smtmBaseData: 'Données de base',
    smtmMlFrame: 'Jeu de données ML',
    smtmModelPublish: 'État du modèle',
    smtmArtifacts: 'Artefacts',
    smtmPredictionFrame: 'Série de prédiction',
    smtmIssues: 'Problèmes',
    smtmNoIssues: 'Aucun problème',
    smtmNoFrames: 'Aucun instrument SMTM trouvé.',
    smtmPredictionControlTitle: 'Contrôle des prédictions SMTM',
    smtmPredictionControlSubtitle: 'Décidez par instrument si SMTM doit calculer de nouvelles prédictions d\'apprentissage automatique ou seulement continuer à collecter les données de base.',
    smtmPredictionSettingsUnavailable: 'Contrôle des prédictions SMTM indisponible',
    smtmPredictionControlHint: 'Les instruments en pause conservent leurs données historiques. Plus aucun jeu ML, entraînement ni prédiction n\'est généré pour eux.',
    smtmPredictionMode: 'Mode de prédiction',
    smtmPredictionToggle: 'Contrôle administrateur',
    smtmPredictionToggleLabel: 'Activer ou mettre en pause les prédictions',
    smtmPredictionEnabled: 'Prédiction activée',
    smtmPredictionDisabled: 'Prédiction en pause',
    smtmPredictionSaving: 'Enregistrement...',
    smtmPredictionSettingsSaved: 'Contrôle des prédictions SMTM enregistré.',
    smtmPredictionSaveChanges: 'Enregistrer les modifications',
    smtmPredictionResetChanges: 'Annuler les modifications',
    smtmPredictionPendingChanges: 'modifications en attente',
    smtmPredictionPendingBadge: 'Enregistrement en attente',
    smtmOpenAzuriteUi: 'Ouvrir l\'interface web Azurite',
    azuriteTitle: 'Interface web Azurite (SMTM)',
    azuriteSubtitle: 'Vue en lecture seule des entrées modelstatus, des artefacts blob et des téléchargements de modèles.',
    azuriteModelGroups: 'Groupes de modèles',
    azuriteBlobArtifacts: 'Artefacts blob',
    azuriteFiles: 'Fichiers',
    azuriteSearchPlaceholder: 'Filtrer les modèles',
    azuriteNoModels: 'Aucun modèle Azurite trouvé.',
    smtmRows: 'Lignes',
    smtmLatest: 'Dernier horodatage',
    smtmAge: 'Ancienneté',
    smtmValue: 'Valeur',
    smtmMinutesAgo: 'min',
    smtmMinutesAhead: 'min à venir',
    smtmHoursAgo: 'h',
    smtmDaysAgo: 'j',
    smtmStateLabels: {
      available: 'Disponible',
      trainable: 'Entraînable',
      waiting_for_history: 'En attente d\'historique',
      missing_base_data: 'Aucune donnée de base',
      missing_machine_learning: 'Jeu de données ML manquant',
      missing_prediction: 'Prédiction manquante',
      prediction_disabled: 'Prédiction en pause',
      stale_prediction: 'Prédiction obsolète',
      open: 'Ouverte',
      completed: 'Terminée',
      online: 'En ligne',
      offline: 'Hors ligne',
      training: 'Entraînement',
      uploading: 'Envoi',
      failed: 'Échec',
      unknown: 'Inconnu',
      missing: 'Manquant'
    },
    smtmIssueLabels: {
      empty_base_frame: 'Série temporelle de base vide',
      insufficient_history: 'Historique insuffisant',
      missing_machine_learning_frame: 'Jeu de données ML manquant',
      missing_prediction_frame: 'Série de prédiction manquante',
      stale_prediction_frame: 'Série de prédiction obsolète',
      missing_online_model: 'Aucun modèle en ligne',
      model_offline: 'Modèle hors ligne',
      missing_model_blob: 'Blob de modèle manquant',
      missing_model_header: 'En-tête de modèle manquant',
      missing_modelstatus_entry: 'Entrée modelstatus manquante',
      inference_not_writing_prediction: 'L\'inférence n\'écrit pas de prédictions',
      prediction_disabled_by_admin: 'Prédiction mise en pause par l\'administrateur'
    },
    smtmHintLabels: {
      trainable_frames_missing_predictions: 'instruments prêts sans sortie de prédiction',
      instruments_waiting_for_history: 'instruments toujours en attente d\'historique',
      models_missing_artifacts: 'modèles en ligne sans artefacts complets',
      no_online_models: 'Aucun modèle en ligne dans Azurite',
      azurite_unavailable: 'L\'état du stockage Azurite est actuellement indisponible'
    },
    mailTitle: 'Configuration de messagerie',
    usersTitle: 'Gestion des utilisateurs',
    usersSubtitle: 'Comptes, rôles, statut et 2FA depuis Keycloak. Sélectionner un compte ouvre les commandes de ce compte précis.',
    usersHideCreate: 'Fermer le formulaire',
    usersCreateHint: 'Un nouveau compte démarre avec la 2FA obligatoire et devient actif dès qu\'elle est configurée.',
    usersFilterAllStatus: 'Tous les états',
    usersFilterAllRoles: 'Tous les rôles',
    usersManage: 'Gérer',
    usersClose: 'Fermer',
    usersNoneFound: 'Aucun utilisateur trouvé.',
    usersPagePrev: 'Précédent',
    usersPageNext: 'Suivant',
    auditTitle: 'Journal d\'audit',
    smtpHost: 'Serveur SMTP',
    smtpPort: 'Port SMTP',
    smtpSecurity: 'Sécurité SMTP',
    smtpUsername: 'Utilisateur SMTP',
    smtpPassword: 'Mot de passe SMTP',
    fromEmail: 'Adresse d\'expédition',
    fromName: 'Nom d\'expéditeur',
    replyToEmail: 'Adresse de réponse',
    saveMailSettings: 'Enregistrer la configuration de messagerie',
    sendTestMail: 'Envoyer un e-mail de test',
    createUser: 'Créer un utilisateur',
    setPassword: 'Définir le mot de passe',
    setRoles: 'Définir les rôles',
    setStatus: 'Définir le statut',
    resetMfa: 'Réinitialiser la 2FA',
    revokeSessions: 'Révoquer les sessions',
    filterUsers: 'Filtrer les utilisateurs',
    testRecipient: 'Destinataire de l\'e-mail de test',
    statusConfigured: 'Configuré',
    statusMissing: 'Non configuré',
    userEmail: 'E-mail',
    userName: 'Nom d\'utilisateur',
    userRoles: 'Rôles',
    userStatus: 'Statut',
    auditEvent: 'Événement',
    auditCreatedAt: 'Créé le',
    auditDetails: 'Détails',
    aiGatewayTitle: 'AI Gateway',
    aiGatewayEndpoint: 'Point d\'accès',
    aiGatewayIdentitySource: 'Identité issue du claim du jeton',
    aiGatewayBudgetSource: 'Valeurs initiales dans',
    aiGatewayModels: 'Modèles routés',
    aiGatewayModel: 'Modèle',
    aiGatewayBackend: 'Backend',
    aiGatewayBudgets: 'Budgets de jetons',
    aiGatewayIdentity: 'Identité',
    aiGatewayTokenBudget: 'Budget de jetons',
    aiGatewayWindow: 'Fenêtre',
    aiGatewayAnyIdentity: 'toute identité',
    aiGatewayAnyModel: 'tout modèle',
    aiUsageWindowStarted: 'Fenêtre depuis',
    aiUsageRemaining: 'Restant',
    aiUsageIdentities: 'Identités',
    aiGatewaySubtitle: 'L\'Envoy AI Gateway est le seul chemin vers un modèle : les modèles routés, leurs backends de service et le budget de jetons de chaque identité.',
    aiGatewayHint: 'Les budgets se pilotent ici. La couche de déploiement ne fait qu\'initialiser les valeurs pour un cluster neuf.',
    aiUsageTitle: 'Consommation IA par identité',
    aiUsageSubtitle: 'Jetons consommés et comptabilisés par la passerelle dans la fenêtre en cours.',
    sessionActiveUsers: 'Utilisateurs connectés',
    sessionActiveSessions: 'Sessions actives',
    sessionMfaSessions: 'Sessions vérifiées',
    aiUsageTotalTokens: 'Total des jetons',
    aiServicesTitle: 'Accès aux services',
    aiServicesSubtitle: 'Liens vers les interfaces d\'API et d\'exploitation de la plateforme ; chaque cible vérifie elle-même le rôle d\'administrateur.',
    aiMailSubtitle: 'Les paramètres SMTP avec lesquels Keycloak envoie les courriels de vérification et de réinitialisation, et l\'envoi de test.',
    tabOverview: 'Vue d\'ensemble',
    tabSmtm: 'SMTM',
    tabEnvoy: 'Envoy AI Gateway',
    tabMail: 'Envoi d\'e-mails',
    tabUsers: 'Utilisateurs',
    tabAudit: 'Journal d\'audit',
    tabServiceLinks: 'Accès aux services',
    tabVeridion: 'Veridion SMTM',
    tabVeridionPaioneer: 'Veridion pAIoneer Labs GmbH',
    tabAgenticRag: 'Agentic RAG',
    tabPlatform: 'Plateforme',
    platformTitle: 'État de la plateforme',
    platformSubtitle: 'Chaque charge de travail pAIoneer Labs GmbH avec ses répliques prêtes, ses redémarrages et son image, directement depuis Kubernetes.',
    platformHostPage: 'Gérer les instances dans l\'hôte d\'applications',
    openVisitorMonitoring: 'Ouvrir le suivi visiteurs, marketing & SEO',
    platformUnavailable: 'État de la plateforme indisponible',
    platformWorkloadsTotal: 'Charges de travail',
    platformDegradedTotal: 'Non prêtes',
    platformRestartsTotal: 'Redémarrages',
    platformWorkload: 'Charge de travail',
    platformNamespace: 'Espace de noms',
    platformReplicas: 'Répliques',
    platformRestarts: 'Redémarrages',
    platformImage: 'Image',
    platformState: 'État',
    platformStateReady: 'Prête',
    platformStateDegraded: 'Dégradée',
    platformStateDown: 'Arrêtée',
    platformStateUnknown: 'Inconnu',
    platformNodes: 'Nœuds',
    platformOsImage: 'Système d\'exploitation',
    platformKernel: 'Noyau',
    platformRuntime: 'Runtime de conteneurs',
    platformKubelet: 'Kubelet',
    platformUsed: 'Utilisé actuellement',
    platformReportedCapacity: 'Signalé par Kubernetes',
    platformConfiguredCap: 'Plafond configuré du conteneur',
    platformPressure: 'Conditions de pression',
    platformPressureNone: 'aucune',
    platformCpu: 'Cœurs CPU',
    platformNoWorkloads: 'Cet espace de noms contient des objets de configuration, aucune charge de travail.',
    platformMemory: 'Mémoire',
    platformEvents: 'Avertissements récents',
    platformEventsNone: 'Aucun avertissement.',
    platformEventObject: 'Objet',
    platformEventReason: 'Motif',
    platformEventMessage: 'Message',
    platformEventLastSeen: 'Vu pour la dernière fois',
    platformMetricsMissing: 'Aucune donnée de consommation : metrics-server ne répond pas.',
    aiGatewayBackends: 'Backends de service',
    gpuTitle: 'Carte graphique',
    gpuNote: 'Charge des moteurs sur la carte graphique, les jetons qui en ont été pris par identité et par bot Webex, et les budgets de jetons par identité et par moteur.',
    gpuTokensWindow: 'Jetons sur la carte graphique dans la fenêtre',
    gpuSinceStart: 'depuis le démarrage du moteur',
    gpuIdentities: 'Par identité, fenêtre en cours',
    gpuBots: 'Par bot Webex et agent, 30 jours',
    gpuBot: 'Bot Webex / agent',
    gpuBudgetTitle: 'Budget par identité pour le moteur',
    gpuBudgetSet: 'Définir le budget',
    gpuBudgetHint: 'Jetons par heure sur le moteur ; la passerelle l\'applique. Il restreint aussi une identité sans limite.',
    gpuNoneYet: 'Rien de comptabilisé pour l\'instant.',
    gpuEngines: 'Moteurs',
    gpuEngine: 'Moteur',
    gpuEngineGold: 'Moteur Or',
    agenticRagTitle: 'Agentic RAG',
    agenticRagSubtitle: 'Exécution, base de connaissances, préparation de l\'entraînement et traçabilité de l\'application Agentic RAG.',
    agenticRagBackendStatus: 'État du backend',
    agenticRagRuntimeMode: 'Mode d\'exécution',
    agenticRagKnowledgeMode: 'Mode de connaissance',
    agenticRagDeploymentEnv: 'Environnement de déploiement',
    agenticRagVectorStores: 'Magasins vectoriels',
    agenticRagQdrantStatus: 'Qdrant',
    agenticRagQdrantCollection: 'Collection de documents',
    agenticRagQdrantCuratedCollection: 'Collection de questions-réponses sélectionnées',
    agenticRagQdrantDashboard: 'Tableau de bord',
    agenticRagPhoenixStatus: 'Phoenix',
    agenticRagOpenDocs: 'Ouvrir Swagger',
    agenticRagOpenPhoenix: 'Ouvrir Phoenix',
    agenticRagOpenQdrant: 'Ouvrir Qdrant',
    agenticRagKnowledgeTitle: 'Base de connaissances',
    agenticRagKnowledgeSubtitle: 'État des documents et des questions-réponses sélectionnées de l\'application Agentic RAG.',
    agenticRagDocuments: 'Documents',
    agenticRagCuratedQaPairs: 'Paires question-réponse sélectionnées',
    agenticRagTrainingTitle: 'Préparation de l\'entraînement',
    agenticRagTrainingSubtitle: 'La dernière exécution du générateur et le dernier état de l\'entraîneur.',
    agenticRagLatestDataset: 'Dernier jeu de données',
    agenticRagDatasetPairs: 'Paires question-réponse',
    agenticRagDatasetDocuments: 'Documents traités',
    agenticRagDatasetModifiedAt: 'Dernière modification',
    agenticRagLatestTrainerInput: 'Dernière entrée de l\'entraîneur',
    agenticRagTrainerInputModifiedAt: 'Entrée modifiée',
    agenticRagLatestTrainerRun: 'Dernière exécution de l\'entraîneur',
    agenticRagTrainerRunModifiedAt: 'Résumé de l\'exécution modifié',
    gpuEngineSilver: 'Moteur Argent',
    gpuAssignment: 'Affectation',
    gpuWho: 'Qui',
    gpuRank: 'Rang',
    gpuRankHint: 'Le rang 0 est servi en premier ; chaque moteur sert par rang.',
    gpuLanes: 'Appels de Veridion Core en cours par moteur et par rang',
    gpuInFlight: 'en cours',
    gpuWhoMainBotPeople: 'Bot principal : conversations avec des personnes',
    gpuWhoMainBotJudgements: 'Bot principal : jugements dans le même tour',
    gpuWhoAutopilot: 'Pilote automatique',
    gpuWhoAgents: 'Agents exécutés par le bot principal',
    gpuWhoArchitect: 'Architecte',
    gpuWhoChair: 'Présidence de la réunion',
    gpuWhoOrchestrator: 'Orchestrateur de l\'instance d\'entreprise',
    gpuWhoColleagues: 'Collègues IA : tours et leurs jugements',
    gpuWhoMeetingWords: 'Collègues IA : interventions en réunion',
    gpuWhoBackgroundReading: 'Service d\'arrière-plan : lecture des messages des bots',
    gpuWhoMemory: 'Mémoire de l\'entreprise : admission et notes',
    gpuWhoCoding: 'Tâches de code : jugements et apprentissage',
    gpuWhoResearch: 'Recherche web et OSINT',
    gpuWhoKnowledgeBase: 'Base de connaissances de l\'entreprise : lecture des pages numérisées',
    gpuWhoPipeline: 'Revue du pipeline au regard de l\'IDD',
    gpuWhoSmtm: 'Veridion SMTM : le chat et la base de connaissances du SaaS, dernier rang',
    gpuUnavailable: 'La carte graphique ne répond pas',
    aiGatewaySource: 'Source',
    aiSourceGpu: 'Carte graphique',
    aiGatewayMeter: 'Compteur',
    aiGatewayMeterIdentity: 'Chaque identité, comptée',
    aiGatewayEngines: 'Moteurs sur la carte graphique',
    aiGatewayEnginesHint: 'Chiffres en direct de chaque moteur d\'après ses métriques : requêtes en cours et en attente, remplissage du cache et jetons servis depuis le démarrage.',
    aiEngineRunning: 'En cours',
    aiEngineWaiting: 'En attente',
    aiEngineCache: 'Cache occupé',
    aiEngineServed: 'Jetons servis',
    aiEngineIdle: 'Aucune requête',
    aiEngineUnavailable: 'Le moteur ne répond pas',
    aiGatewayServing: 'Prêt',
    aiBudgetControlTitle: 'Piloter les budgets de jetons',
    aiBudgetControlSubtitle: 'Le budget par défaut s\'applique à toutes les identités. Une identité donnée peut recevoir son propre plafond.',
    aiBudgetDefault: 'Budget par défaut',
    aiBudgetIdentity: 'Identité',
    aiBudgetTokens: 'Jetons',
    aiBudgetApply: 'Appliquer',
    aiBudgetAdd: 'Définir un plafond',
    aiBudgetRemove: 'Retirer',
    aiBudgetSaved: 'Budget de jetons appliqué.',
    aiBudgetIdentityPlaceholder: 'Id de client, p. ex. paioneer-agent-veridion-smtm',
    aiBudgetUnlimited: 'Sans limite',
    aiBudgetSetUnlimited: 'Lever la limite',
    aiBudgetRestoreLimit: 'Rétablir la limite',
    aiUsageReset: 'Vider la fenêtre',
    aiUsageResetDone: 'Fenêtre en cours vidée.',
    userMfa: '2FA',
    userMfaOn: 'Configurée',
    userMfaOff: 'Absente',
    userCreatedAt: 'Créé le',
    mailSource: 'Géré dans',
    veridionTitle: 'Veridion SMTM',
    veridionSubtitle: "Noyau conversationnel de l'assistant de trading : exécution, registre d'outils, serveurs MCP et activité.",
    veridionOpenPage: 'Ouvrir Veridion',
    veridionOpenDocs: 'Ouvrir Swagger',
    veridionCoreStatus: 'Veridion MCP orchestrator',
    veridionTools: 'Outils',
    veridionToolsTitle: 'Registre d\'outils',
    veridionToolsSubtitle: 'Affiche les familles d\'outils chargées et leur état effectif.',
    veridionToolName: 'Outil',
    veridionToolRuntime: 'Runtime',
    veridionToolRisk: 'Risque',
    veridionToolEnabled: 'Activé',
    veridionNoTools: 'Aucun outil Veridion n\'est chargé.',
    veridionRuntimeProfiles: 'Profils de runtime',
    veridionRegistryReloaded: 'Registre rechargé',
    veridionProvider: 'Chemin IA',
    veridionMcpTitle: 'Serveurs MCP',
    veridionMcpSubtitle: "Serveurs d'outils externes connectés, avec leur état et leur nombre d'outils.",
    veridionMcpServer: 'Serveur',
    veridionMcpState: 'État',
    veridionMcpTools: 'Outils',
    veridionMcpLastSuccess: 'Dernier contact',
    veridionMcpConnected: 'connecté',
    veridionMcpUnreachable: 'injoignable',
    veridionMcpDisabled: 'désactivé',
    veridionMcpEmpty: 'Aucun serveur MCP configuré.',
    veridionActivityTitle: 'Fil d\'activité',
    veridionActivitySubtitle: 'Événements d\'exécution structurés de l\'orchestrateur et de ses outils.',
    veridionActivityEmpty: 'Aucune activité enregistrée pour l\'instant.',
    veridionActivitySource: 'Source',
    veridionActivitySurface: 'Surface',
    veridionActivityEvent: 'Événement',
    veridionActivityTool: 'Outil',
    veridionActivityStatus: 'Statut',
    veridionActivitySummary: 'Résumé',
    veridionUnavailable: 'Veridion est actuellement indisponible.',
    veridionNotConfigured: 'Veridion n\'est pas encore entièrement configuré dans le runtime de la Homepage.',
    veridionRequestFailed: 'Veridion n\'a pas mené à bien l\'appel d\'administration demandé.',
    companyTitle: 'Veridion pAIoneer Labs GmbH',
    companySubtitle: 'L\'instance Veridion de pAIoneer Labs GmbH pour ses collaborateurs dans Webex, avec YouTrack et sa propre base de connaissances ; ses appels de modèles passent par l\'Envoy AI Gateway.',
    companyWorkloads: 'Charges de travail',
    companyTokensWindow: 'Jetons dans la fenêtre en cours',
    companyBudget: 'Budget',
    companyBudgetDefault: 'budget par défaut',
    companyCost30: 'Coût des 30 derniers jours',
    openrouterTitle: 'Facturé par OpenRouter',
    openrouterRemaining: 'Crédit restant',
    openrouterOf: 'sur',
    openrouterToday: 'Aujourd’hui',
    openrouterWeek: 'Cette semaine',
    openrouterMonth: 'Ce mois-ci',
    openrouterUnavailable: 'OpenRouter est illisible pour le moment',
    openrouterNote: 'La facturation d\'OpenRouter pour la clé de la plateforme, en dollars américains ; jour et semaine en UTC. Les valeurs comptabilisées ci-dessous ne comptent que les réponses qui indiquent leur coût et sont donc plus basses.',
    companyRequests30: 'Appels au modèle des 30 derniers jours',
    companyCostNote: "Coût en dollars américains tel qu'OpenRouter l'indique par requête ; l'Envoy AI Gateway impute les jetons à l'identité {identity}.",
    companyCostNotReported: 'non communiqué',
    companyPartUnavailable: 'injoignable',
    companyWebexTitle: 'Bot Webex',
    companyWebexSubtitle: "Webex appelle webex.paioneer-labs.eu/hook ; le pont vérifie la signature et l'expéditeur et ne transmet à Veridion que les messages autorisés.",
    companyWebexBot: 'Bot',
    companyWebexWebhook: 'Webhook',
    companyWebexRegistered: 'enregistré',
    companyWebexNotRegistered: 'non enregistré',
    companyWebexAccess: 'Autorisés',
    companyWebexAnswered: 'Répondus',
    companyWebexRejected: 'Refusés',
    companyWebexFailed: 'Échecs',
    companyWebexRecent: 'Livraisons récentes',
    companyWebexTime: 'Heure',
    companyWebexOutcome: 'Résultat',
    companyWebexReason: 'Motif',
    companyWebexSender: 'Expéditeur',
    companyWebexEmpty: 'Aucune livraison depuis le dernier démarrage.',
    companyWebexNotConfigured: "Le pont Webex est injoignable ou sa clé de statut manque dans l'API d'administration.",
    companyUsageTitle: 'Utilisation par personne',
    companyUsageSubtitle: "Appels au modèle, jetons et coût des 30 derniers jours, issus du registre d'utilisation de l'instance.",
    companyUsagePerson: 'Personne',
    companyUsageCalls: 'Appels',
    companyUsageTokens: 'Jetons',
    companyUsageCost: 'Coût (USD)',
    companyUsageEmpty: 'Aucun appel au modèle au cours des 30 derniers jours.',
    companyWebexSendTitle: 'Écrire en tant que bot',
    companyWebexSendPerson: 'À une personne',
    companyWebexSendRoom: 'Dans un espace du bot',
    companyWebexSendEmail: 'Adresse e-mail dans Webex',
    companyWebexSendText: 'Message (Markdown)',
    companyWebexSendButton: 'Envoyer',
    companyWebexSendDone: 'Envoyé.',
    companyWebexSendFailed: 'Échec',
    companyWebexRooms: 'Espaces du bot',
    companyWebexRoomGroup: 'groupe',
    companyWebexRoomDirect: 'direct',
    companyWebexRoomsEmpty: "Le bot n'est encore dans aucun espace.",
    companyKnowledgeTitle: 'Base de connaissances',
    companyKnowledgeSubtitle: 'Les documents de la base de connaissances de l\'instance de l\'entreprise (Agentic RAG) ; l\'orchestrateur les consulte quand un tour de conversation l\'exige. Phoenix journalise chaque recherche.',
    companyKnowledgeDocument: 'Document',
    companyKnowledgeSize: 'Taille',
    companyKnowledgeModified: 'Ajouté',
    companyKnowledgeDelete: 'Retirer',
    companyKnowledgeDeleteConfirm: 'Retirer {name} de la base de connaissances ?',
    companyKnowledgeUpload: 'Ajouter un document',
    companyKnowledgeUploading: 'Téléversement …',
    companyKnowledgeIntake: 'Intégration',
    companyKnowledgePhoenix: 'Explainable AI (Phoenix)',
    companyKnowledgeEmpty: 'La base de connaissances est vide.',
    companyKnowledgeNotConfigured: "La base de connaissances n'est pas reliée à l'API d'administration.",
    companyGuestsTitle: 'Invités ayant accès',
    companyGuestsHint: "Toute adresse en {domains} peut utiliser le bot. Les administrateurs ajoutent ici des adresses externes isolées ; la modification s'applique immédiatement.",
    companyGuestsEmail: 'Adresse e-mail',
    companyGuestsAdd: 'Ajouter',
    companyGuestsRemove: 'Retirer',
    companyGuestsRemoveConfirm: "Retirer à {email} l'accès au bot ?",
    companyGuestsAddedBy: 'Ajouté par',
    companyGuestsAddedAt: 'Ajouté le',
    companyGuestsEmpty: 'Aucun invité.',
    companyGuestsNotPersistent: "La liste n'est pas enregistrée : le pont n'a pas de répertoire de données.",
    companyGuestsLoadFailed: "La liste enregistrée était illisible ; aucun invité n'a accès jusqu'à la prochaine modification.",
    companyErrorRecipientNotAllowed: "Cette adresse ne peut pas répondre au bot. Ajoutez-la d'abord comme invité, puis envoyez.",
    companyErrorDomainAllowed: 'Les adresses de ce domaine ont déjà accès.',
    companyErrorInvalidEmail: 'Adresse e-mail non valide.',
    companyErrorAlreadyListed: 'Cette adresse figure déjà dans la liste.',
    companyErrorStoreUnwritable: "La liste n'a pas pu être enregistrée.",
    smtmFilterTitle: 'Filtre d\'instruments SMTM',
    smtmFilterSubtitle: 'Une saisie vide affiche tous les instruments ; plusieurs noms d\'instruments sont séparés par des virgules, par exemple EUR-USD_FOREX_intraday_data_l1,BitcoinEUR_CRYPTO_intraday_data_l1.',
    smtmFilterPlaceholder: 'Noms d\'instruments, séparés par des virgules',
    smtmFilterApply: 'Appliquer le filtre',
    smtmFilterClear: 'Effacer le filtre',
    smtmReportingTitle: 'Rapport de signaux SMTM',
    smtmReportingSubtitle: 'Affiche les signaux d\'achat qualifiés, leur évaluation de sortie et l\'état d\'envoi des notifications automatiques.',
    smtmReportingUnavailable: 'Rapport SMTM indisponible',
    smtmReportingQualifiedSignals: 'Signaux qualifiés',
    smtmReportingOpenSignals: 'Signaux ouverts',
    smtmReportingResolvedSignals: 'Signaux clôturés',
    smtmReportingWins: 'Gains',
    smtmReportingLosses: 'Pertes',
    smtmReportingWinRate: 'Taux de réussite',
    smtmReportingAverageActualReturn: 'Rendement réel moyen',
    smtmReportingNetActualReturn: 'Rendement réel net',
    smtmReportingDeliveryFailed: 'Envois échoués',
    smtmReportingEntryTime: 'Heure d\'entrée',
    smtmReportingExitTime: 'Heure de sortie',
    smtmReportingExpectedReturn: 'Rendement attendu',
    smtmReportingActualReturn: 'Rendement réel',
    smtmReportingSignalStatus: 'État du signal',
    smtmReportingNoSignals: 'Aucun signal qualifié enregistré pour l\'instant.',
    smtmReportingPendingDeliveries: 'Envois en attente',
    smtmReportingFailedDeliveries: 'Envois échoués',
    smtmReportingDeliveryError: 'Erreur d\'envoi',
    smtmTrainingTitle: 'Entraînement et modèles SMTM',
    smtmTrainingSubtitle: 'Affiche la qualité de l\'entraînement, l\'état des modèles et les artefacts publiés par le service d\'entraînement.',
    smtmTrainingUnavailable: 'Entraînement SMTM indisponible',
    smtmTrainingModels: 'Modèles',
    smtmTrainingOnlineModels: 'Modèles en ligne',
    smtmTrainingFailedModels: 'Modèles en échec',
    smtmTrainingStaleModels: 'Modèles obsolètes',
    smtmTrainingAverageMae: 'MAE moyen',
    smtmTrainingAverageRmse: 'RMSE moyen',
    smtmTrainingAverageR2: 'R² moyen',
    smtmTrainingAverageMase: 'MASE moyen',
    smtmTrainingAverageHitRate: 'Taux de direction moyen',
    smtmTrainingHitRate: 'Taux de direction',
    smtmTrainingLastSuccess: 'Dernier entraînement réussi',
    smtmTrainingResolution: 'Résolution / horizon',
    smtmTrainingConsoleTitle: 'Console d\'entraînement SMTM',
    smtmTrainingConsoleSubtitle: 'Suivi en direct de la sortie du service d\'entraînement.',
    smtmTrainingConsoleUnavailable: 'Console d\'entraînement SMTM indisponible',
    smtmTrainingConsoleEmpty: 'Aucune sortie d\'entraînement pour l\'instant.',
    smtmRuntimeTitle: 'Runtime SMTM',
    smtmRuntimeSubtitle: 'Horizon global, état de reconstruction et vanne de prédiction du système SMTM en production.',
    smtmRuntimeUnavailable: 'Runtime SMTM indisponible',
    smtmRuntimeForecastHorizon: 'Horizon de prévision',
    smtmRuntimeResolution: 'Résolution',
    smtmRuntimeConfigVersion: 'Version de configuration',
    smtmRuntimePredictionGate: 'Vanne de prédiction',
    smtmRuntimeRebuild: 'Reconstruction',
    smtmRuntimeStateOpen: 'ouverte',
    smtmRuntimeStateClosed: 'fermée',
    smtmRuntimeStateActive: 'active',
    smtmRuntimeStateIdle: 'au repos',
    smtmRuntimeForecastHorizonMinutes: 'Minutes de l\'horizon de prévision',
    smtmRuntimeResolutionMinutes: 'Minutes de résolution',
    smtmRuntimeRequireCompletedBars: 'Exiger des bougies complètes',
    smtmRuntimePredictionGateOpen: 'Vanne de prédiction ouverte',
    smtmRuntimeRebuildActive: 'Reconstruction active',
    smtmRuntimeSaving: 'Enregistrement du runtime...',
    smtmRuntimeSave: 'Enregistrer les réglages du runtime',
    smtmRuntimeReset: 'Annuler les modifications du runtime',
    smtmRuntimeSaved: 'Réglages du runtime SMTM enregistrés.',
    smtmTrainingRows: 'Lignes entraînement / test',
    smtmTrainingMetrics: 'Métriques',
    smtmTrainingIssues: 'Problèmes d\'entraînement',
    smtmTrainingLlmFeatures: 'Caractéristiques LLM',
    smtmTrainingNoModels: 'Aucun modèle d\'entraînement en cache.',
    smtmDirection: 'Direction',
    smtmSentiment: 'Sentiment',
    smtmDeliveryStage: 'Étape',
    smtmDeliveryRecipient: 'Destinataire',
    mailSettingsSaved: 'Configuration de messagerie enregistrée.',
    mailTestSent: 'E-mail de test envoyé.',
    userCreatedSuccess: 'Utilisateur créé avec succès.',
    userUpdatedSuccess: 'Utilisateur mis à jour avec succès.',
    userDeletedSuccess: 'Utilisateur supprimé avec succès.',
    deleteUser: 'Supprimer l\'utilisateur',
    roleLabels: {
      admin: 'Administrateur',
      pro: 'Pro',
      tester: 'Testeur',
      user: 'Utilisateur'
    },
    statusLabels: {
      pending_email_verification: 'Vérification d\'e-mail en attente',
      pending_mfa: '2FA en attente',
      active: 'Actif',
      locked: 'Verrouillé',
      disabled: 'Désactivé'
    }
  },
  footer: {
    managingDirectors: 'Gérants',
    servicesTitle: 'Services',
    legal: {
      title: 'Informations légales',
      imprint: 'Mentions légales',
      privacy: 'Politique de confidentialité',
      aiTransparency: 'Transparence en matière d’IA',
      cookieSettings: 'Paramètres des cookies',
      terms: 'Conditions générales'
    },
    copyright: 'Tous droits réservés.'
  },
  auth: {
    validating: 'Validation en cours...',
    errors: {
      registrationFailed: 'Échec de l\'inscription : ',
      unknownError: 'Erreur inconnue'
    }
  },
  account: {
    username: 'Nom d\'utilisateur',
    email: 'E-mail',
    roles: 'Rôles',
    manageText: 'Vous gérez votre mot de passe, l\'authentification à deux facteurs, les sessions actives et votre adresse e-mail dans la gestion du compte.',
    manageButton: 'Ouvrir la gestion du compte',
    signedOut: 'Vous n\'êtes pas connecté.'
  },
  cookies: {
    title: 'Paramètres de confidentialité',
    description: 'Nous analysons les statistiques de visite à l’aide de méthodes d’apprentissage automatique afin d’améliorer notre site web. Avec votre consentement, nous traitons à cette fin des données d’utilisation et d’appareil, y compris votre adresse IP, et reconnaissons votre navigateur lors de visites ultérieures. Le consentement est facultatif et peut être retiré à tout moment sous « {settings} ». Les détails, y compris sur les transferts vers des pays tiers, figurent dans la politique de confidentialité.',
    necessary: {
      title: 'Nécessaires',
      description: 'Indispensables au fonctionnement du site, par exemple le choix de la langue et l’enregistrement de cette sélection.'
    },
    statistics: {
      title: 'Statistiques',
      description: 'Pages consultées et utilisation du site, sans reconnaissance et sans enregistrement de l’adresse IP.'
    },
    marketing: {
      title: 'Analyse et apprentissage automatique',
      description: 'Reconnaissance lors de visites ultérieures et analyse de l’adresse IP (localisation approximative, opérateur réseau, organisation) et des caractéristiques de l’appareil ; conservation jusqu’à douze mois après la dernière visite. Votre adresse IP est alors également transmise à des registres Internet aux États-Unis, en Australie et à Maurice, pour lesquels aucun niveau adéquat de protection des données n’a été constaté ; il existe un risque d’accès par les autorités de ces pays et de difficultés accrues pour faire valoir vos droits.'
    },
    acceptAll: 'Tout accepter',
    rejectAll: 'Nécessaires uniquement',
    settings: 'Paramètres',
    save: 'Enregistrer la sélection',
    alwaysOn: 'Toujours actifs'
  },
  pages: {
    teaching: {
      hero: { title: 'Formation IA en périphérie et EU AI Act', subtitle: 'Conseil en IA d’entreprise • Développement en périphérie • Mise en œuvre conforme au droit' },
      intro: 'Des formations spécialisées en IA pour dirigeants, chefs de projet et équipes de développement. Du conseil stratégique à la mise en œuvre technique, en conformité avec l’EU AI Act.',
      eu_ai_act: {
        title: 'Conformité à l’EU AI Act et edge computing',
        subtitle: 'Une mise en œuvre de l’IA juridiquement sûre grâce au traitement local des données',
        description: 'L’EU AI Act fixe des règles strictes pour l’utilisation de l’intelligence artificielle en Europe. L’edge computing offre la solution idéale : les données sensibles restent en local, la conformité est simplifiée et le contrôle des systèmes d’IA reste entre vos mains.',
        benefits: ['Protection des données grâce au traitement local', 'Complexité de mise en conformité réduite', 'Contrôle total des décisions de l’IA', 'Transparence et traçabilité', 'Risques juridiques réduits au minimum', 'Indépendance vis-à-vis des fournisseurs de cloud'],
        highlight: 'Edge computing + EU AI Act = une IA juridiquement sûre, sans compromis'
      },
      offerings: {
        title: 'Offre de formation',
        categories: [
          { title: 'Intelligence artificielle et apprentissage automatique', icon: 'brain', topics: ['IA générative et grands modèles de langage (en périphérie et dans le cloud)', 'Apprentissage automatique classique (optimisé pour la périphérie)', 'Apprentissage profond et réseaux de neurones (déploiement en périphérie)', 'Vision par ordinateur et NLP (solutions exploitables en périphérie)', 'Systèmes RAG et fine-tuning de LLM (en périphérie et dans le cloud)', 'Agents IA autonomes (edge computing)', 'Conformité à l’EU AI Act et sécurité juridique'] },
          { title: 'Science des données et statistiques', icon: 'chart', topics: ['Statistiques descriptives et inférentielles', 'Modélisation et analyse de données', 'Analyse de séries temporelles', 'Économétrie pour la gestion et l’économie', 'Biostatistique pour les sciences naturelles', 'Tests A/B et plans d’expérience'] },
          { title: 'Architecture logicielle et sécurité', icon: 'shield', topics: ['Architectures modulaires', 'Couplage faible et code propre', 'Conception de microservices', 'Sécurité informatique et conformité', 'DevOps et CI/CD', 'Architectures cloud'] }
        ]
      },
      target_groups: {
        title: 'Publics cibles',
        groups: [
          { title: 'Direction générale et décideurs', description: 'Conseil stratégique en IA, analyse des coûts et décisions d’investissement', formats: ['Briefings pour dirigeants', 'Analyses de ROI', 'Conseil en stratégie'], focus: 'Études de rentabilité, conformité à l’EU AI Act, planification budgétaire' },
          { title: 'Chefs de projet et managers', description: 'Gestion de projets IA, choix technologiques et stratégies de mise en œuvre', formats: ['Ateliers pour managers', 'Évaluations technologiques', 'Élaboration de feuilles de route'], focus: 'Planification de projet, sélection des fournisseurs, gestion des risques' },
          { title: 'Développeurs et ingénieurs informatiques', description: 'Développement pratique d’IA en périphérie, mise en œuvre technique et déploiement', formats: ['Approfondissements techniques', 'Revues de code', 'Ateliers d’architecture'], focus: 'Edge computing, fine-tuning de LLM, intégration de systèmes' },
          { title: 'Collaborateurs des métiers', description: 'Compréhension de l’IA, techniques de prompting et application pratique au quotidien professionnel', formats: ['Formation des utilisateurs', 'Ateliers de prompting', 'Élaboration de cas d’usage'], focus: 'Application pratique, intégration dans les flux de travail, gains de productivité' },
          { title: 'Étudiants et universitaires', description: 'Enseignement universitaire, soutien et encadrement de projets scientifiques', formats: ['Cours magistraux', 'Tutorat', 'Encadrement de mémoires et de thèses'], focus: 'Statistiques, économétrie, méthodes de recherche' }
        ]
      },
      expertise: {
        title: 'Expertise technique',
        items: ['Élaboration de feuilles de route IA stratégiques pour les entreprises', 'Systèmes d’IA en périphérie avec architectures RAG/GRAG et fine-tuning LoRA/QLoRA', 'Stratégies de conformité à l’EU AI Act et mise en œuvre juridiquement sûre', 'Analyses de ROI et planification des investissements pour les projets IA', 'Agents IA autonomes dotés d’outils et de capacités de raisonnement', 'Conduite du changement pour l’adoption de l’IA dans les organisations', 'Stratégies cloud et sur site (Azure, STACKIT)', 'Ingénierie de prompts et optimisation des flux de travail']
      },
      technologies: { title: 'Socle technologique', list: 'Python, R, PyTorch, TensorFlow, CUDA, Docker, React, Azure, STACKIT, JupyterLab, Google Colab, Hugging Face, SPSS, Stata' },
      clients: { title: 'Secteurs et institutions', sectors: ['Caisses d’assurance maladie', 'Édition', 'Banque et fintech', 'Industrie et IoT', 'Recherche et universités', 'Conseil', 'Start-up'] },
      workshops: {
        title: 'Formats proposés',
        formats: [
          { title: 'Briefing pour dirigeants', duration: '2-4 heures', description: 'Vue d’ensemble stratégique pour la direction, axée sur le ROI et l’EU AI Act' },
          { title: 'Atelier pour managers', duration: '1-2 jours', description: 'Formation des chefs de projet à la mise en œuvre de l’IA et à la conduite du changement' },
          { title: 'Approfondissement technique', duration: '2-5 jours', description: 'Développement pratique d’IA en périphérie pour les équipes informatiques et les ingénieurs' },
          { title: 'Formation des utilisateurs', duration: '0,5-1 jour', description: 'Application pratique de l’IA pour les collaborateurs des métiers' },
          { title: 'Coaching individuel', duration: 'Selon les besoins', description: 'Accompagnement personnalisé et soutien de projet' }
        ]
      },
      sidebar: {
        languagesLabel: 'Langues :',
        languagesValue: 'DE / EN / NL',
        focusLabel: 'Thèmes clés :',
        specializationTitle: 'Spécialisation',
        specializationItems: ['IA en périphérie pour un traitement local des données, sans dépendance au cloud', 'Mise en œuvre conforme à l’EU AI Act pour la sécurité juridique'],
        benefitsTitle: 'Avantages',
        benefits: ['Adapté au public cible', 'Immédiatement applicable', 'Axé sur le ROI', 'À distance ou sur site']
      },
      cta: {
        title: 'Prêt pour une transformation stratégique par l’IA ?',
        description: 'Du conseil aux dirigeants à la mise en œuvre technique : parlons de vos besoins spécifiques.',
        button: 'Demander une consultation',
        email: 'info@paioneer.eu',
        subject: 'Demande de formation'
      }
    },
    agenticdev: {
      seo: {
        title: 'Intent-Driven Development (IDD) pour le codage agentique | pAIoneer Labs GmbH',
        description: 'Intent-Driven Development rend le développement logiciel assisté par l’IA maîtrisable : le sens, les décisions et les scénarios deviennent des artefacts opérationnels pour le codage agentique.',
        keywords: 'Intent-Driven Development, Intent Driven Development, IDD, codage agentique, agentic coding, développement logiciel agentique, développement logiciel assisté par l’IA, vibe coding, Spec-Driven Development, ingénierie de prompts, ingénierie des exigences avec l’IA',
        ogTitle: 'Intent-Driven Development : le sens avant l’implémentation',
        ogDescription: 'IDD rend le contexte opérationnel avant l’écriture du code : Intent, Decisions et Scenarios deviennent la mémoire du projet pour le développement logiciel agentique.',
        twitterTitle: 'Intent-Driven Development (IDD) pour le codage agentique',
        twitterDescription: 'Du code maîtrisable plutôt que le chaos des prompts : IDD transforme le sens, les décisions et les scénarios en artefacts opérationnels.',
        url: 'https://paioneer-labs.eu/agenticdev',
        structuredData: { '@context': 'https://schema.org', '@type': 'Service', name: 'Intent-Driven Development (IDD) pour le codage agentique', serviceType: 'Développement logiciel agentique et processus de développement assistés par l’IA', description: 'Conseil et mise en œuvre pour Intent-Driven Development, les IDD Vaults, les flux de travail de codage agentique et un développement logiciel assisté par l’IA vérifiable.', provider: { '@type': 'Organization', name: 'pAIoneer Labs GmbH', url: 'https://paioneer-labs.eu' }, areaServed: 'DE, NL, EU', url: 'https://paioneer-labs.eu/agenticdev' }
      },
      hero: { eyebrow: 'Le codage agentique a besoin d’un contexte explicite', title: 'Intent-Driven Development', claim: 'Le sens avant l’implémentation.', lead: 'L’IA écrit le code. IDD veille à ce qu’elle travaille sur le bon problème. Intent-Driven Development transforme les objectifs, les limites, les décisions et les scénarios en artefacts opérationnels pour le développement logiciel agentique.' },
      implicitContextProblem: { title: 'Le risque, c’est le contexte implicite', intro: 'Le véritable risque du développement logiciel assisté par l’IA n’est pas le code manquant. Le risque, c’est le contexte qui reste caché dans la tête de quelqu’un, dans un historique de chat ou dans des tickets dispersés.', items: [{ title: 'Mission floue', description: 'Les prompts décrivent souvent une solution, mais pas l’objectif, les non-objectifs, les critères de réussite ni les hypothèses. L’IA travaille alors vite, mais pas nécessairement dans la bonne direction.' }, { title: 'Architecture accidentelle', description: 'Les décisions technologiques se prennent en passant : la persistance, le choix du modèle, les cas de défaillance et l’exploitation sont décidés implicitement au lieu d’être conduits délibérément.' }, { title: 'Résultat invérifiable', description: 'Sans scénarios ni critères d’acceptation, on ne sait pas si le code se comporte réellement correctement ou s’il a seulement l’air plausible.' }], resolution: 'IDD résout précisément ce problème : le sens est d’abord rendu opérationnel, puis le code en est dérivé.' },
      antiVibeCoding: { title: 'Le vibe coding n’est pas un processus de développement', description: 'L’intuition peut suffire pour des démos. Elle ne suffit pas pour des logiciels qui impliquent exploitation, maintenance, sécurité, coûts et responsabilité. Les agents n’ont pas besoin de plus de « vibes », mais d’un contexte explicite.', contrasts: ['Le vibe coding crée du mouvement. IDD crée une direction.', 'Le prompting crée des réponses. IDD crée une mémoire de projet.', 'Le codage agentique sans IDD reste de l’activité. Le codage agentique avec IDD devient un développement maîtrisable.'] },
      principle: { title: 'La documentation n’est pas un sous-produit', thesis: 'Dans IDD, la documentation est un artefact opérationnel.', description: 'La documentation ne sert pas au reporting. Elle est l’espace de travail dans lequel les objectifs, les limites, les décisions et le comportement attendu deviennent explicites avant que les agents n’implémentent.', pillarsTitle: 'Intent. Decisions. Scenarios. Code.', pillarsIntro: 'IDD ne réduit pas le développement logiciel à des prompts. Il rend explicite le sens d’un projet et en dérive une implémentation vérifiable.', pillars: [{ title: 'Intent', description: 'Que faut-il atteindre, qu’est-ce qui est expressément hors périmètre et à quoi reconnaît-on le succès ?' }, { title: 'Decisions', description: 'Quelles décisions importantes ont été prises, dans quel contexte et avec quelles conséquences ?' }, { title: 'Scenarios', description: 'Quel comportement est attendu dans les cas normaux, les cas limites, les cas de défaillance et les situations d’acceptation ?' }, { title: 'Code', description: 'L’implémentation naît du sens documenté et est vérifiée au regard des scénarios et des étapes de vérification.' }] },
      vault: { title: 'L’IDD Vault : une mémoire de projet plutôt qu’un historique de prompts', description: 'L’IDD Vault conserve le contexte pertinent là où les agents et les humains peuvent le réutiliser. Pas plus de fichiers que nécessaire. Chaque fichier a une fonction claire.', rule: 'Peu d’artefacts. Une fonction claire. Un contexte durable.', effect: 'Le Vault empêche le contexte décisif de disparaître dans le chat, dans la tête de quelqu’un ou dans des tickets dispersés.', treeLines: ['/project', '  /idd_vault', '    intent.md       # objectif, non-objectifs, critères de réussite, hypothèses', '    decisions.md    # décisions avec contexte, justification, conséquences', '    scenarios.md    # comportement, cas limites, critères d’acceptation', '  /code', '  AGENTS.md         # règles et attentes pour les agents de code', '  README.md         # point d’entrée, installation, mode d’exploitation, limites'] },
      outputs: { title: 'Pas du texte. Du code maîtrisable.', description: 'Les fichiers IDD ne sont pas un rapport. Ils servent d’entrée au travail concret d’implémentation et permettent de réinjecter les enseignements dans le projet.', items: [{ file: 'intent.md', result: 'Périmètre', description: 'Les points de terminaison, le modèle de données, les critères de réussite, les non-objectifs et les hypothèses deviennent visibles et forment le cadre du développement.' }, { file: 'decisions.md', result: 'Architecture', description: 'La technologie, l’exploitation, la persistance, le choix du modèle et les compromis sont justifiés au lieu d’être décidés en passant.' }, { file: 'scenarios.md', result: 'Tests', description: 'Les tests d’acceptation, les cas de défaillance, les transitions d’état et les cas limites apparaissent avant ou pendant l’implémentation.' }, { file: 'AGENTS.md', result: 'Qualité du code', description: 'Les règles, les patterns, les contraintes, les migrations, OpenAPI et les résultats attendus deviennent explicites pour les agents.' }, { file: 'README.md', result: 'Point d’entrée', description: 'L’installation, le mode d’exploitation, les limites et les exemples de déroulement restent compréhensibles pour les humains comme pour les agents.' }, { file: 'Code', result: 'Boucle de rétroaction', description: 'Les enseignements tirés de l’implémentation et de la vérification retournent dans le Vault, les tests et l’itération suivante.' }] },
      comparison: { title: 'IDD commence avant la spécification', intro: 'Spec-Driven Development est efficace lorsque l’objectif est déjà techniquement précis et stable. IDD intervient plus tôt : là où le domaine, les hypothèses, les compromis et les cas de défaillance doivent encore être rendus explicites.', columns: ['Approche', 'Centre', 'Force', 'Limite'], rows: [{ approach: 'Prompting', center: 'Entrée fournie à un modèle', strength: 'Rapide et direct', limit: 'Éphémère, incomplet et difficile à vérifier' }, { approach: 'Vibe Coding', center: 'Intuition et itération', strength: 'Utile pour les terrains d’essai et les démos', limit: 'Pas de pilotage fiable pour un logiciel dont on doit répondre' }, { approach: 'Spec-Driven Development', center: 'Contrat technique', strength: 'Cohérence par rapport à une spécification déjà définie', limit: 'Le mauvais problème peut être implémenté de façon formellement correcte' }, { approach: 'Intent-Driven Development', center: 'Sens, objectif et décisions', strength: 'Clarifie le contexte, les compromis et les limites avant l’implémentation', limit: 'Exige un entretien rigoureux du contexte et une validation' }], summary: 'Les spécifications disent ce qui doit être techniquement vrai. IDD explique pourquoi c’est précisément cette direction qu’il faut construire.' },
      workflow: { title: 'Clarifier. Décider. Formuler. Construire. Réinjecter.', description: 'IDD n’est pas un cycle en cascade. IDD est une itération courte et maîtrisée, avec un contexte durable.', steps: [{ title: 'Clarifier l’intention', description: 'Les objectifs, les non-objectifs, les critères de réussite et les hypothèses deviennent visibles avant l’écriture du code.' }, { title: 'Documenter les décisions', description: 'Les décisions d’architecture et de produit sont consignées avec leur contexte, leur justification et leurs conséquences.' }, { title: 'Formuler les scénarios', description: 'Le comportement normal, les cas limites, les cas de défaillance et les critères d’acceptation sont décrits sous une forme vérifiable.' }, { title: 'Laisser les agents implémenter', description: 'Les agents IA travaillent à partir d’un contexte explicite plutôt que de prompts isolés.' }, { title: 'Vérifier et réinjecter', description: 'Les enseignements tirés du code, des tests et de l’exploitation mettent à jour le Vault et l’itération suivante.' }] },
      impact: { title: 'Pourquoi cela compte dans les projets réels', description: 'IDD permet au développement assisté par l’IA de s’articuler avec les équipes, l’exploitation et l’assurance qualité.', items: ['Moins de reprises, car les objectifs et les non-objectifs sont visibles.', 'Une meilleure architecture, car les décisions sont justifiées.', 'De meilleurs tests, car les scénarios existent avant le code.', 'Une meilleure collaboration, car le contexte ne disparaît pas dans le chat.', 'De meilleurs résultats des agents, car chaque étape repose sur des artefacts explicites.'] },
      contact: { title: 'Introduire IDD dans les processus de développement agentique', description: 'Si le développement assisté par l’IA doit être plus qu’une expérimentation, il lui faut un modèle de contexte opérationnel.', details: 'Nous accompagnons la mise en place d’IDD Vaults, de règles d’agents, de scénarios et de processus de développement vérifiables.', button: 'Parler d’IDD', subject: 'Échange sur Intent-Driven Development', email: 'info@paioneer.eu' }
    },
    impressum: injectPersonalData('fr', baseTranslationFR)
  }
};
